var $d = Object.defineProperty;
var hi = (e) => {
  throw TypeError(e);
};
var Md = (e, t, r) => t in e ? $d(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Ae = (e, t, r) => Md(e, typeof t != "symbol" ? t + "" : t, r), pi = (e, t, r) => t.has(e) || hi("Cannot " + r);
var _ = (e, t, r) => (pi(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Oe = (e, t, r) => t.has(e) ? hi("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), ke = (e, t, r, n) => (pi(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var Nd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
};
function jd(e) {
  return e;
}
function $e(e, t, r, n, a, s, i, o, c) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return s(a(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return i(s(a(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return o(i(s(a(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return c(o(i(s(a(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function b(e, t, r, n, a, s, i, o, c) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return a(n(r(t(e))));
    case 6:
      return s(a(n(r(t(e)))));
    case 7:
      return i(s(a(n(r(t(e))))));
    case 8:
      return o(i(s(a(n(r(t(e)))))));
    case 9:
      return c(o(i(s(a(n(r(t(e))))))));
    default: {
      for (var l = arguments[0], h = 1; h < arguments.length; h++)
        l = arguments[h](l);
      return l;
    }
  }
}
var Dd = function(e, t) {
  var r = function(n) {
    return n.length >= e;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(a) {
      return t.apply(void 0, Nd([a], n, !1));
    };
  };
}, Hd = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, Ld = function(e) {
  return Hd(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
}, Xu = function(e) {
  return e._tag === "Some";
}, ec = { _tag: "None" }, tc = function(e) {
  return { _tag: "Some", value: e };
}, Ud = function(e) {
  return e._tag === "Left";
}, Kd = function(e) {
  return e._tag === "Right";
}, Bd = function(e) {
  return { _tag: "Left", left: e };
}, Gd = function(e) {
  return { _tag: "Right", right: e };
}, Fd = function(e) {
  return [e];
}, Zd = [], Wd = Object.prototype.hasOwnProperty, Jd = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, a) {
        return e.concat(n, a);
      }, t);
    };
  };
}, zd = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var a in e)
        Wd.call(e, a) && (n[a] = e[a].concat(t[a], r[a]));
      return n;
    }
  };
}, Br = function() {
  return { concat: jd };
}, Qd = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, Yd = Jd, yi = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Xd = Zd, ef = function(e, t) {
  return e < 0 || e >= t.length;
}, tf = function(e) {
  return function(t) {
    return yi(yi([], t, !0), [e], !1);
  };
}, rf = tf, nf = Fd, Pe = {
  equals: function(e, t) {
    return e === t;
  }
}, af = {
  concat: function(e, t) {
    return e + t;
  }
}, sf = "", _s = {
  concat: af.concat,
  empty: sf
};
Pe.equals;
var rc = function(e) {
  return e.trim();
}, nc = function(e) {
  return e.length === 0;
}, er = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ac(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Gr, mi;
function of() {
  if (mi) return Gr;
  mi = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Gr = e, Gr;
}
var Fr, vi;
function bs() {
  if (vi) return Fr;
  vi = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Fr = e, Fr;
}
var Zr, gi;
function vr() {
  if (gi) return Zr;
  gi = 1;
  var e = bs();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return Zr = t, Zr;
}
var Wr, _i;
function uf() {
  if (_i) return Wr;
  _i = 1;
  var e = vr(), t = Array.prototype, r = t.splice;
  function n(a) {
    var s = this.__data__, i = e(s, a);
    if (i < 0)
      return !1;
    var o = s.length - 1;
    return i == o ? s.pop() : r.call(s, i, 1), --this.size, !0;
  }
  return Wr = n, Wr;
}
var Jr, bi;
function cf() {
  if (bi) return Jr;
  bi = 1;
  var e = vr();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return Jr = t, Jr;
}
var zr, Si;
function lf() {
  if (Si) return zr;
  Si = 1;
  var e = vr();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return zr = t, zr;
}
var Qr, Ai;
function df() {
  if (Ai) return Qr;
  Ai = 1;
  var e = vr();
  function t(r, n) {
    var a = this.__data__, s = e(a, r);
    return s < 0 ? (++this.size, a.push([r, n])) : a[s][1] = n, this;
  }
  return Qr = t, Qr;
}
var Yr, Ti;
function gr() {
  if (Ti) return Yr;
  Ti = 1;
  var e = of(), t = uf(), r = cf(), n = lf(), a = df();
  function s(i) {
    var o = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++o < c; ) {
      var l = i[o];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, Yr = s, Yr;
}
var Xr, Ei;
function ff() {
  if (Ei) return Xr;
  Ei = 1;
  var e = gr();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Xr = t, Xr;
}
var en, Ri;
function hf() {
  if (Ri) return en;
  Ri = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return en = e, en;
}
var tn, wi;
function pf() {
  if (wi) return tn;
  wi = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return tn = e, tn;
}
var rn, Ci;
function yf() {
  if (Ci) return rn;
  Ci = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return rn = e, rn;
}
var nn, Ii;
function sc() {
  if (Ii) return nn;
  Ii = 1;
  var e = typeof er == "object" && er && er.Object === Object && er;
  return nn = e, nn;
}
var an, xi;
function me() {
  if (xi) return an;
  xi = 1;
  var e = sc(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return an = r, an;
}
var sn, Oi;
function _r() {
  if (Oi) return sn;
  Oi = 1;
  var e = me(), t = e.Symbol;
  return sn = t, sn;
}
var on, ki;
function mf() {
  if (ki) return on;
  ki = 1;
  var e = _r(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function s(i) {
    var o = r.call(i, a), c = i[a];
    try {
      i[a] = void 0;
      var l = !0;
    } catch {
    }
    var h = n.call(i);
    return l && (o ? i[a] = c : delete i[a]), h;
  }
  return on = s, on;
}
var un, Pi;
function vf() {
  if (Pi) return un;
  Pi = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return un = r, un;
}
var cn, qi;
function br() {
  if (qi) return cn;
  qi = 1;
  var e = _r(), t = mf(), r = vf(), n = "[object Null]", a = "[object Undefined]", s = e ? e.toStringTag : void 0;
  function i(o) {
    return o == null ? o === void 0 ? a : n : s && s in Object(o) ? t(o) : r(o);
  }
  return cn = i, cn;
}
var ln, Vi;
function Lt() {
  if (Vi) return ln;
  Vi = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return ln = e, ln;
}
var dn, $i;
function ic() {
  if ($i) return dn;
  $i = 1;
  var e = br(), t = Lt(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", s = "[object Proxy]";
  function i(o) {
    if (!t(o))
      return !1;
    var c = e(o);
    return c == n || c == a || c == r || c == s;
  }
  return dn = i, dn;
}
var fn, Mi;
function gf() {
  if (Mi) return fn;
  Mi = 1;
  var e = me(), t = e["__core-js_shared__"];
  return fn = t, fn;
}
var hn, Ni;
function _f() {
  if (Ni) return hn;
  Ni = 1;
  var e = gf(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return hn = r, hn;
}
var pn, ji;
function oc() {
  if (ji) return pn;
  ji = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return pn = r, pn;
}
var yn, Di;
function bf() {
  if (Di) return yn;
  Di = 1;
  var e = ic(), t = _f(), r = Lt(), n = oc(), a = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, i = Function.prototype, o = Object.prototype, c = i.toString, l = o.hasOwnProperty, h = RegExp(
    "^" + c.call(l).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function m(E) {
    if (!r(E) || t(E))
      return !1;
    var j = e(E) ? h : s;
    return j.test(n(E));
  }
  return yn = m, yn;
}
var mn, Hi;
function Sf() {
  if (Hi) return mn;
  Hi = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return mn = e, mn;
}
var vn, Li;
function et() {
  if (Li) return vn;
  Li = 1;
  var e = bf(), t = Sf();
  function r(n, a) {
    var s = t(n, a);
    return e(s) ? s : void 0;
  }
  return vn = r, vn;
}
var gn, Ui;
function Ss() {
  if (Ui) return gn;
  Ui = 1;
  var e = et(), t = me(), r = e(t, "Map");
  return gn = r, gn;
}
var _n, Ki;
function Sr() {
  if (Ki) return _n;
  Ki = 1;
  var e = et(), t = e(Object, "create");
  return _n = t, _n;
}
var bn, Bi;
function Af() {
  if (Bi) return bn;
  Bi = 1;
  var e = Sr();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return bn = t, bn;
}
var Sn, Gi;
function Tf() {
  if (Gi) return Sn;
  Gi = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Sn = e, Sn;
}
var An, Fi;
function Ef() {
  if (Fi) return An;
  Fi = 1;
  var e = Sr(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    var i = this.__data__;
    if (e) {
      var o = i[s];
      return o === t ? void 0 : o;
    }
    return n.call(i, s) ? i[s] : void 0;
  }
  return An = a, An;
}
var Tn, Zi;
function Rf() {
  if (Zi) return Tn;
  Zi = 1;
  var e = Sr(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var s = this.__data__;
    return e ? s[a] !== void 0 : r.call(s, a);
  }
  return Tn = n, Tn;
}
var En, Wi;
function wf() {
  if (Wi) return En;
  Wi = 1;
  var e = Sr(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var s = this.__data__;
    return this.size += this.has(n) ? 0 : 1, s[n] = e && a === void 0 ? t : a, this;
  }
  return En = r, En;
}
var Rn, Ji;
function Cf() {
  if (Ji) return Rn;
  Ji = 1;
  var e = Af(), t = Tf(), r = Ef(), n = Rf(), a = wf();
  function s(i) {
    var o = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++o < c; ) {
      var l = i[o];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, Rn = s, Rn;
}
var wn, zi;
function If() {
  if (zi) return wn;
  zi = 1;
  var e = Cf(), t = gr(), r = Ss();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return wn = n, wn;
}
var Cn, Qi;
function xf() {
  if (Qi) return Cn;
  Qi = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Cn = e, Cn;
}
var In, Yi;
function Ar() {
  if (Yi) return In;
  Yi = 1;
  var e = xf();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return In = t, In;
}
var xn, Xi;
function Of() {
  if (Xi) return xn;
  Xi = 1;
  var e = Ar();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return xn = t, xn;
}
var On, eo;
function kf() {
  if (eo) return On;
  eo = 1;
  var e = Ar();
  function t(r) {
    return e(this, r).get(r);
  }
  return On = t, On;
}
var kn, to;
function Pf() {
  if (to) return kn;
  to = 1;
  var e = Ar();
  function t(r) {
    return e(this, r).has(r);
  }
  return kn = t, kn;
}
var Pn, ro;
function qf() {
  if (ro) return Pn;
  ro = 1;
  var e = Ar();
  function t(r, n) {
    var a = e(this, r), s = a.size;
    return a.set(r, n), this.size += a.size == s ? 0 : 1, this;
  }
  return Pn = t, Pn;
}
var qn, no;
function uc() {
  if (no) return qn;
  no = 1;
  var e = If(), t = Of(), r = kf(), n = Pf(), a = qf();
  function s(i) {
    var o = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++o < c; ) {
      var l = i[o];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, qn = s, qn;
}
var Vn, ao;
function Vf() {
  if (ao) return Vn;
  ao = 1;
  var e = gr(), t = Ss(), r = uc(), n = 200;
  function a(s, i) {
    var o = this.__data__;
    if (o instanceof e) {
      var c = o.__data__;
      if (!t || c.length < n - 1)
        return c.push([s, i]), this.size = ++o.size, this;
      o = this.__data__ = new r(c);
    }
    return o.set(s, i), this.size = o.size, this;
  }
  return Vn = a, Vn;
}
var $n, so;
function cc() {
  if (so) return $n;
  so = 1;
  var e = gr(), t = ff(), r = hf(), n = pf(), a = yf(), s = Vf();
  function i(o) {
    var c = this.__data__ = new e(o);
    this.size = c.size;
  }
  return i.prototype.clear = t, i.prototype.delete = r, i.prototype.get = n, i.prototype.has = a, i.prototype.set = s, $n = i, $n;
}
var Mn, io;
function $f() {
  if (io) return Mn;
  io = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a && r(t[n], n, t) !== !1; )
      ;
    return t;
  }
  return Mn = e, Mn;
}
var Nn, oo;
function Mf() {
  if (oo) return Nn;
  oo = 1;
  var e = et(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Nn = t, Nn;
}
var jn, uo;
function lc() {
  if (uo) return jn;
  uo = 1;
  var e = Mf();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return jn = t, jn;
}
var Dn, co;
function dc() {
  if (co) return Dn;
  co = 1;
  var e = lc(), t = bs(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o) {
    var c = s[i];
    (!(n.call(s, i) && t(c, o)) || o === void 0 && !(i in s)) && e(s, i, o);
  }
  return Dn = a, Dn;
}
var Hn, lo;
function Tr() {
  if (lo) return Hn;
  lo = 1;
  var e = dc(), t = lc();
  function r(n, a, s, i) {
    var o = !s;
    s || (s = {});
    for (var c = -1, l = a.length; ++c < l; ) {
      var h = a[c], m = i ? i(s[h], n[h], h, s, n) : void 0;
      m === void 0 && (m = n[h]), o ? t(s, h, m) : e(s, h, m);
    }
    return s;
  }
  return Hn = r, Hn;
}
var Ln, fo;
function Nf() {
  if (fo) return Ln;
  fo = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return Ln = e, Ln;
}
var Un, ho;
function Rt() {
  if (ho) return Un;
  ho = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Un = e, Un;
}
var Kn, po;
function jf() {
  if (po) return Kn;
  po = 1;
  var e = br(), t = Rt(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Kn = n, Kn;
}
var Bn, yo;
function Df() {
  if (yo) return Bn;
  yo = 1;
  var e = jf(), t = Rt(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, s = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(i) {
    return t(i) && n.call(i, "callee") && !a.call(i, "callee");
  };
  return Bn = s, Bn;
}
var Gn, mo;
function Er() {
  if (mo) return Gn;
  mo = 1;
  var e = Array.isArray;
  return Gn = e, Gn;
}
var Ot = { exports: {} }, Fn, vo;
function Hf() {
  if (vo) return Fn;
  vo = 1;
  function e() {
    return !1;
  }
  return Fn = e, Fn;
}
Ot.exports;
var go;
function As() {
  return go || (go = 1, (function(e, t) {
    var r = me(), n = Hf(), a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, i = s && s.exports === a, o = i ? r.Buffer : void 0, c = o ? o.isBuffer : void 0, l = c || n;
    e.exports = l;
  })(Ot, Ot.exports)), Ot.exports;
}
var Zn, _o;
function Lf() {
  if (_o) return Zn;
  _o = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var s = typeof n;
    return a = a ?? e, !!a && (s == "number" || s != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return Zn = r, Zn;
}
var Wn, bo;
function fc() {
  if (bo) return Wn;
  bo = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Wn = t, Wn;
}
var Jn, So;
function Uf() {
  if (So) return Jn;
  So = 1;
  var e = br(), t = fc(), r = Rt(), n = "[object Arguments]", a = "[object Array]", s = "[object Boolean]", i = "[object Date]", o = "[object Error]", c = "[object Function]", l = "[object Map]", h = "[object Number]", m = "[object Object]", E = "[object RegExp]", j = "[object Set]", Z = "[object String]", D = "[object WeakMap]", M = "[object ArrayBuffer]", $ = "[object DataView]", I = "[object Float32Array]", B = "[object Float64Array]", P = "[object Int8Array]", G = "[object Int16Array]", q = "[object Int32Array]", O = "[object Uint8Array]", J = "[object Uint8ClampedArray]", H = "[object Uint16Array]", ae = "[object Uint32Array]", x = {};
  x[I] = x[B] = x[P] = x[G] = x[q] = x[O] = x[J] = x[H] = x[ae] = !0, x[n] = x[a] = x[M] = x[s] = x[$] = x[i] = x[o] = x[c] = x[l] = x[h] = x[m] = x[E] = x[j] = x[Z] = x[D] = !1;
  function te(ie) {
    return r(ie) && t(ie.length) && !!x[e(ie)];
  }
  return Jn = te, Jn;
}
var zn, Ao;
function Ts() {
  if (Ao) return zn;
  Ao = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return zn = e, zn;
}
var kt = { exports: {} };
kt.exports;
var To;
function Es() {
  return To || (To = 1, (function(e, t) {
    var r = sc(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s && r.process, o = (function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || i && i.binding && i.binding("util");
      } catch {
      }
    })();
    e.exports = o;
  })(kt, kt.exports)), kt.exports;
}
var Qn, Eo;
function hc() {
  if (Eo) return Qn;
  Eo = 1;
  var e = Uf(), t = Ts(), r = Es(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return Qn = a, Qn;
}
var Yn, Ro;
function pc() {
  if (Ro) return Yn;
  Ro = 1;
  var e = Nf(), t = Df(), r = Er(), n = As(), a = Lf(), s = hc(), i = Object.prototype, o = i.hasOwnProperty;
  function c(l, h) {
    var m = r(l), E = !m && t(l), j = !m && !E && n(l), Z = !m && !E && !j && s(l), D = m || E || j || Z, M = D ? e(l.length, String) : [], $ = M.length;
    for (var I in l)
      (h || o.call(l, I)) && !(D && // Safari 9 has enumerable `arguments.length` in strict mode.
      (I == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      j && (I == "offset" || I == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Z && (I == "buffer" || I == "byteLength" || I == "byteOffset") || // Skip index properties.
      a(I, $))) && M.push(I);
    return M;
  }
  return Yn = c, Yn;
}
var Xn, wo;
function Rs() {
  if (wo) return Xn;
  wo = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return Xn = t, Xn;
}
var ea, Co;
function yc() {
  if (Co) return ea;
  Co = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return ea = e, ea;
}
var ta, Io;
function Kf() {
  if (Io) return ta;
  Io = 1;
  var e = yc(), t = e(Object.keys, Object);
  return ta = t, ta;
}
var ra, xo;
function Bf() {
  if (xo) return ra;
  xo = 1;
  var e = Rs(), t = Kf(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    if (!e(s))
      return t(s);
    var i = [];
    for (var o in Object(s))
      n.call(s, o) && o != "constructor" && i.push(o);
    return i;
  }
  return ra = a, ra;
}
var na, Oo;
function mc() {
  if (Oo) return na;
  Oo = 1;
  var e = ic(), t = fc();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return na = r, na;
}
var aa, ko;
function ws() {
  if (ko) return aa;
  ko = 1;
  var e = pc(), t = Bf(), r = mc();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return aa = n, aa;
}
var sa, Po;
function Gf() {
  if (Po) return sa;
  Po = 1;
  var e = Tr(), t = ws();
  function r(n, a) {
    return n && e(a, t(a), n);
  }
  return sa = r, sa;
}
var ia, qo;
function Ff() {
  if (qo) return ia;
  qo = 1;
  function e(t) {
    var r = [];
    if (t != null)
      for (var n in Object(t))
        r.push(n);
    return r;
  }
  return ia = e, ia;
}
var oa, Vo;
function Zf() {
  if (Vo) return oa;
  Vo = 1;
  var e = Lt(), t = Rs(), r = Ff(), n = Object.prototype, a = n.hasOwnProperty;
  function s(i) {
    if (!e(i))
      return r(i);
    var o = t(i), c = [];
    for (var l in i)
      l == "constructor" && (o || !a.call(i, l)) || c.push(l);
    return c;
  }
  return oa = s, oa;
}
var ua, $o;
function Cs() {
  if ($o) return ua;
  $o = 1;
  var e = pc(), t = Zf(), r = mc();
  function n(a) {
    return r(a) ? e(a, !0) : t(a);
  }
  return ua = n, ua;
}
var ca, Mo;
function Wf() {
  if (Mo) return ca;
  Mo = 1;
  var e = Tr(), t = Cs();
  function r(n, a) {
    return n && e(a, t(a), n);
  }
  return ca = r, ca;
}
var Pt = { exports: {} };
Pt.exports;
var No;
function Jf() {
  return No || (No = 1, (function(e, t) {
    var r = me(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s ? r.Buffer : void 0, o = i ? i.allocUnsafe : void 0;
    function c(l, h) {
      if (h)
        return l.slice();
      var m = l.length, E = o ? o(m) : new l.constructor(m);
      return l.copy(E), E;
    }
    e.exports = c;
  })(Pt, Pt.exports)), Pt.exports;
}
var la, jo;
function zf() {
  if (jo) return la;
  jo = 1;
  function e(t, r) {
    var n = -1, a = t.length;
    for (r || (r = Array(a)); ++n < a; )
      r[n] = t[n];
    return r;
  }
  return la = e, la;
}
var da, Do;
function Qf() {
  if (Do) return da;
  Do = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, s = 0, i = []; ++n < a; ) {
      var o = t[n];
      r(o, n, t) && (i[s++] = o);
    }
    return i;
  }
  return da = e, da;
}
var fa, Ho;
function vc() {
  if (Ho) return fa;
  Ho = 1;
  function e() {
    return [];
  }
  return fa = e, fa;
}
var ha, Lo;
function Is() {
  if (Lo) return ha;
  Lo = 1;
  var e = Qf(), t = vc(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, s = a ? function(i) {
    return i == null ? [] : (i = Object(i), e(a(i), function(o) {
      return n.call(i, o);
    }));
  } : t;
  return ha = s, ha;
}
var pa, Uo;
function Yf() {
  if (Uo) return pa;
  Uo = 1;
  var e = Tr(), t = Is();
  function r(n, a) {
    return e(n, t(n), a);
  }
  return pa = r, pa;
}
var ya, Ko;
function gc() {
  if (Ko) return ya;
  Ko = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, s = t.length; ++n < a; )
      t[s + n] = r[n];
    return t;
  }
  return ya = e, ya;
}
var ma, Bo;
function _c() {
  if (Bo) return ma;
  Bo = 1;
  var e = yc(), t = e(Object.getPrototypeOf, Object);
  return ma = t, ma;
}
var va, Go;
function bc() {
  if (Go) return va;
  Go = 1;
  var e = gc(), t = _c(), r = Is(), n = vc(), a = Object.getOwnPropertySymbols, s = a ? function(i) {
    for (var o = []; i; )
      e(o, r(i)), i = t(i);
    return o;
  } : n;
  return va = s, va;
}
var ga, Fo;
function Xf() {
  if (Fo) return ga;
  Fo = 1;
  var e = Tr(), t = bc();
  function r(n, a) {
    return e(n, t(n), a);
  }
  return ga = r, ga;
}
var _a, Zo;
function Sc() {
  if (Zo) return _a;
  Zo = 1;
  var e = gc(), t = Er();
  function r(n, a, s) {
    var i = a(n);
    return t(n) ? i : e(i, s(n));
  }
  return _a = r, _a;
}
var ba, Wo;
function Ac() {
  if (Wo) return ba;
  Wo = 1;
  var e = Sc(), t = Is(), r = ws();
  function n(a) {
    return e(a, r, t);
  }
  return ba = n, ba;
}
var Sa, Jo;
function eh() {
  if (Jo) return Sa;
  Jo = 1;
  var e = Sc(), t = bc(), r = Cs();
  function n(a) {
    return e(a, r, t);
  }
  return Sa = n, Sa;
}
var Aa, zo;
function th() {
  if (zo) return Aa;
  zo = 1;
  var e = et(), t = me(), r = e(t, "DataView");
  return Aa = r, Aa;
}
var Ta, Qo;
function rh() {
  if (Qo) return Ta;
  Qo = 1;
  var e = et(), t = me(), r = e(t, "Promise");
  return Ta = r, Ta;
}
var Ea, Yo;
function nh() {
  if (Yo) return Ea;
  Yo = 1;
  var e = et(), t = me(), r = e(t, "Set");
  return Ea = r, Ea;
}
var Ra, Xo;
function ah() {
  if (Xo) return Ra;
  Xo = 1;
  var e = et(), t = me(), r = e(t, "WeakMap");
  return Ra = r, Ra;
}
var wa, eu;
function Rr() {
  if (eu) return wa;
  eu = 1;
  var e = th(), t = Ss(), r = rh(), n = nh(), a = ah(), s = br(), i = oc(), o = "[object Map]", c = "[object Object]", l = "[object Promise]", h = "[object Set]", m = "[object WeakMap]", E = "[object DataView]", j = i(e), Z = i(t), D = i(r), M = i(n), $ = i(a), I = s;
  return (e && I(new e(new ArrayBuffer(1))) != E || t && I(new t()) != o || r && I(r.resolve()) != l || n && I(new n()) != h || a && I(new a()) != m) && (I = function(B) {
    var P = s(B), G = P == c ? B.constructor : void 0, q = G ? i(G) : "";
    if (q)
      switch (q) {
        case j:
          return E;
        case Z:
          return o;
        case D:
          return l;
        case M:
          return h;
        case $:
          return m;
      }
    return P;
  }), wa = I, wa;
}
var Ca, tu;
function sh() {
  if (tu) return Ca;
  tu = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function r(n) {
    var a = n.length, s = new n.constructor(a);
    return a && typeof n[0] == "string" && t.call(n, "index") && (s.index = n.index, s.input = n.input), s;
  }
  return Ca = r, Ca;
}
var Ia, ru;
function Tc() {
  if (ru) return Ia;
  ru = 1;
  var e = me(), t = e.Uint8Array;
  return Ia = t, Ia;
}
var xa, nu;
function xs() {
  if (nu) return xa;
  nu = 1;
  var e = Tc();
  function t(r) {
    var n = new r.constructor(r.byteLength);
    return new e(n).set(new e(r)), n;
  }
  return xa = t, xa;
}
var Oa, au;
function ih() {
  if (au) return Oa;
  au = 1;
  var e = xs();
  function t(r, n) {
    var a = n ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Oa = t, Oa;
}
var ka, su;
function oh() {
  if (su) return ka;
  su = 1;
  var e = /\w*$/;
  function t(r) {
    var n = new r.constructor(r.source, e.exec(r));
    return n.lastIndex = r.lastIndex, n;
  }
  return ka = t, ka;
}
var Pa, iu;
function uh() {
  if (iu) return Pa;
  iu = 1;
  var e = _r(), t = e ? e.prototype : void 0, r = t ? t.valueOf : void 0;
  function n(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Pa = n, Pa;
}
var qa, ou;
function ch() {
  if (ou) return qa;
  ou = 1;
  var e = xs();
  function t(r, n) {
    var a = n ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return qa = t, qa;
}
var Va, uu;
function lh() {
  if (uu) return Va;
  uu = 1;
  var e = xs(), t = ih(), r = oh(), n = uh(), a = ch(), s = "[object Boolean]", i = "[object Date]", o = "[object Map]", c = "[object Number]", l = "[object RegExp]", h = "[object Set]", m = "[object String]", E = "[object Symbol]", j = "[object ArrayBuffer]", Z = "[object DataView]", D = "[object Float32Array]", M = "[object Float64Array]", $ = "[object Int8Array]", I = "[object Int16Array]", B = "[object Int32Array]", P = "[object Uint8Array]", G = "[object Uint8ClampedArray]", q = "[object Uint16Array]", O = "[object Uint32Array]";
  function J(H, ae, x) {
    var te = H.constructor;
    switch (ae) {
      case j:
        return e(H);
      case s:
      case i:
        return new te(+H);
      case Z:
        return t(H, x);
      case D:
      case M:
      case $:
      case I:
      case B:
      case P:
      case G:
      case q:
      case O:
        return a(H, x);
      case o:
        return new te();
      case c:
      case m:
        return new te(H);
      case l:
        return r(H);
      case h:
        return new te();
      case E:
        return n(H);
    }
  }
  return Va = J, Va;
}
var $a, cu;
function dh() {
  if (cu) return $a;
  cu = 1;
  var e = Lt(), t = Object.create, r = /* @__PURE__ */ (function() {
    function n() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (t)
        return t(a);
      n.prototype = a;
      var s = new n();
      return n.prototype = void 0, s;
    };
  })();
  return $a = r, $a;
}
var Ma, lu;
function fh() {
  if (lu) return Ma;
  lu = 1;
  var e = dh(), t = _c(), r = Rs();
  function n(a) {
    return typeof a.constructor == "function" && !r(a) ? e(t(a)) : {};
  }
  return Ma = n, Ma;
}
var Na, du;
function hh() {
  if (du) return Na;
  du = 1;
  var e = Rr(), t = Rt(), r = "[object Map]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Na = n, Na;
}
var ja, fu;
function ph() {
  if (fu) return ja;
  fu = 1;
  var e = hh(), t = Ts(), r = Es(), n = r && r.isMap, a = n ? t(n) : e;
  return ja = a, ja;
}
var Da, hu;
function yh() {
  if (hu) return Da;
  hu = 1;
  var e = Rr(), t = Rt(), r = "[object Set]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Da = n, Da;
}
var Ha, pu;
function mh() {
  if (pu) return Ha;
  pu = 1;
  var e = yh(), t = Ts(), r = Es(), n = r && r.isSet, a = n ? t(n) : e;
  return Ha = a, Ha;
}
var La, yu;
function vh() {
  if (yu) return La;
  yu = 1;
  var e = cc(), t = $f(), r = dc(), n = Gf(), a = Wf(), s = Jf(), i = zf(), o = Yf(), c = Xf(), l = Ac(), h = eh(), m = Rr(), E = sh(), j = lh(), Z = fh(), D = Er(), M = As(), $ = ph(), I = Lt(), B = mh(), P = ws(), G = Cs(), q = 1, O = 2, J = 4, H = "[object Arguments]", ae = "[object Array]", x = "[object Boolean]", te = "[object Date]", ie = "[object Error]", st = "[object Function]", it = "[object GeneratorFunction]", Kr = "[object Map]", yd = "[object Number]", ui = "[object Object]", md = "[object RegExp]", vd = "[object Set]", gd = "[object String]", _d = "[object Symbol]", bd = "[object WeakMap]", Sd = "[object ArrayBuffer]", Ad = "[object DataView]", Td = "[object Float32Array]", Ed = "[object Float64Array]", Rd = "[object Int8Array]", wd = "[object Int16Array]", Cd = "[object Int32Array]", Id = "[object Uint8Array]", xd = "[object Uint8ClampedArray]", Od = "[object Uint16Array]", kd = "[object Uint32Array]", L = {};
  L[H] = L[ae] = L[Sd] = L[Ad] = L[x] = L[te] = L[Td] = L[Ed] = L[Rd] = L[wd] = L[Cd] = L[Kr] = L[yd] = L[ui] = L[md] = L[vd] = L[gd] = L[_d] = L[Id] = L[xd] = L[Od] = L[kd] = !0, L[ie] = L[st] = L[bd] = !1;
  function zt(N, ot, ut, Pd, Qt, Ie) {
    var se, Yt = ot & q, Xt = ot & O, qd = ot & J;
    if (ut && (se = Qt ? ut(N, Pd, Qt, Ie) : ut(N)), se !== void 0)
      return se;
    if (!I(N))
      return N;
    var ci = D(N);
    if (ci) {
      if (se = E(N), !Yt)
        return i(N, se);
    } else {
      var ct = m(N), li = ct == st || ct == it;
      if (M(N))
        return s(N, Yt);
      if (ct == ui || ct == H || li && !Qt) {
        if (se = Xt || li ? {} : Z(N), !Yt)
          return Xt ? c(N, a(se, N)) : o(N, n(se, N));
      } else {
        if (!L[ct])
          return Qt ? N : {};
        se = j(N, ct, Yt);
      }
    }
    Ie || (Ie = new e());
    var di = Ie.get(N);
    if (di)
      return di;
    Ie.set(N, se), B(N) ? N.forEach(function(xe) {
      se.add(zt(xe, ot, ut, xe, N, Ie));
    }) : $(N) && N.forEach(function(xe, Fe) {
      se.set(Fe, zt(xe, ot, ut, Fe, N, Ie));
    });
    var Vd = qd ? Xt ? h : l : Xt ? G : P, fi = ci ? void 0 : Vd(N);
    return t(fi || N, function(xe, Fe) {
      fi && (Fe = xe, xe = N[Fe]), r(se, Fe, zt(xe, ot, ut, Fe, N, Ie));
    }), se;
  }
  return La = zt, La;
}
var Ua, mu;
function gh() {
  if (mu) return Ua;
  mu = 1;
  var e = vh(), t = 1, r = 4;
  function n(a) {
    return e(a, t | r);
  }
  return Ua = n, Ua;
}
var _h = gh();
const bh = /* @__PURE__ */ ac(_h);
var V;
(function(e) {
  e.assertEqual = (a) => {
  };
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return e.objectValues(i);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, e.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(V || (V = {}));
var vu;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(vu || (vu = {}));
const v = V.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), qe = (e) => {
  switch (typeof e) {
    case "undefined":
      return v.undefined;
    case "string":
      return v.string;
    case "number":
      return Number.isNaN(e) ? v.nan : v.number;
    case "boolean":
      return v.boolean;
    case "function":
      return v.function;
    case "bigint":
      return v.bigint;
    case "symbol":
      return v.symbol;
    case "object":
      return Array.isArray(e) ? v.array : e === null ? v.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? v.promise : typeof Map < "u" && e instanceof Map ? v.map : typeof Set < "u" && e instanceof Set ? v.set : typeof Date < "u" && e instanceof Date ? v.date : v.object;
    default:
      return v.unknown;
  }
}, p = V.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Ce extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, c = 0;
          for (; c < i.path.length; ) {
            const l = i.path[c];
            c === i.path.length - 1 ? (o[l] = o[l] || { _errors: [] }, o[l]._errors.push(r(i))) : o[l] = o[l] || { _errors: [] }, o = o[l], c++;
          }
        }
    };
    return a(this), n;
  }
  static assert(t) {
    if (!(t instanceof Ce))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, V.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Ce.create = (e) => new Ce(e);
const us = (e, t) => {
  let r;
  switch (e.code) {
    case p.invalid_type:
      e.received === v.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case p.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, V.jsonStringifyReplacer)}`;
      break;
    case p.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${V.joinValues(e.keys, ", ")}`;
      break;
    case p.invalid_union:
      r = "Invalid input";
      break;
    case p.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${V.joinValues(e.options)}`;
      break;
    case p.invalid_enum_value:
      r = `Invalid enum value. Expected ${V.joinValues(e.options)}, received '${e.received}'`;
      break;
    case p.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case p.invalid_return_type:
      r = "Invalid function return type";
      break;
    case p.invalid_date:
      r = "Invalid date";
      break;
    case p.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : V.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case p.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case p.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case p.custom:
      r = "Invalid input";
      break;
    case p.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case p.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case p.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, V.assertNever(e);
  }
  return { message: r };
};
let Sh = us;
function Ah() {
  return Sh;
}
const Th = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const c = n.filter((l) => !!l).slice().reverse();
  for (const l of c)
    o = l(i, { data: t, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function y(e, t) {
  const r = Ah(), n = Th({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === us ? void 0 : us
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(n);
}
class re {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return R;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return re.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return R;
      s.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: t.value, value: n };
  }
}
const R = Object.freeze({
  status: "aborted"
}), qt = (e) => ({ status: "dirty", value: e }), le = (e) => ({ status: "valid", value: e }), gu = (e) => e.status === "aborted", _u = (e) => e.status === "dirty", gt = (e) => e.status === "valid", tr = (e) => typeof Promise < "u" && e instanceof Promise;
var g;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(g || (g = {}));
var rr = function(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, Ec = function(e, t, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, Vt, $t;
class pe {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const bu = (e, t) => {
  if (gt(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Ce(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function w(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (i, o) => {
    const { message: c } = e;
    return i.code === "invalid_enum_value" ? { message: c ?? o.defaultError } : typeof o.data > "u" ? { message: c ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: c ?? r ?? o.defaultError };
  }, description: a };
}
class k {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return qe(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: qe(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new re(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: qe(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (tr(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: qe(t)
    }, a = this._parseSync({ data: t, path: n.path, parent: n });
    return bu(n, a);
  }
  "~validate"(t) {
    var n, a;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: qe(t)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: t, path: [], parent: r });
        return gt(s) ? {
          value: s.value
        } : {
          issues: r.common.issues
        };
      } catch (s) {
        (a = (n = s == null ? void 0 : s.message) == null ? void 0 : n.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((s) => gt(s) ? {
      value: s.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: qe(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), s = await (tr(a) ? a : Promise.resolve(a));
    return bu(n, s);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = t(a), o = () => s.addIssue({
        code: p.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((c) => c ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new Ye({
      schema: this,
      typeName: T.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return we.create(this, this._def);
  }
  nullable() {
    return Xe.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return he.create(this);
  }
  promise() {
    return cr.create(this, this._def);
  }
  or(t) {
    return ar.create([this, t], this._def);
  }
  and(t) {
    return sr.create(this, t, this._def);
  }
  transform(t) {
    return new Ye({
      ...w(this._def),
      schema: this,
      typeName: T.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new lr({
      ...w(this._def),
      innerType: this,
      defaultValue: r,
      typeName: T.ZodDefault
    });
  }
  brand() {
    return new Ic({
      typeName: T.ZodBranded,
      type: this,
      ...w(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new dr({
      ...w(this._def),
      innerType: this,
      catchValue: r,
      typeName: T.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return ks.create(this, t);
  }
  readonly() {
    return fr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Eh = /^c[^\s-]{8,}$/i, Rh = /^[0-9a-z]+$/, wh = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Ch = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ih = /^[a-z0-9_-]{21}$/i, xh = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Oh = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, kh = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Ph = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ka;
const qh = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Vh = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, $h = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Mh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Nh = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, jh = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Rc = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Dh = new RegExp(`^${Rc}$`);
function wc(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function Hh(e) {
  return new RegExp(`^${wc(e)}$`);
}
function Lh(e) {
  let t = `${Rc}T${wc(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function Uh(e, t) {
  return !!((t === "v4" || !t) && qh.test(e) || (t === "v6" || !t) && $h.test(e));
}
function Kh(e, t) {
  if (!xh.test(e))
    return !1;
  try {
    const [r] = e.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || "typ" in a && (a == null ? void 0 : a.typ) !== "JWT" || !a.alg || t && a.alg !== t);
  } catch {
    return !1;
  }
}
function Bh(e, t) {
  return !!((t === "v4" || !t) && Vh.test(e) || (t === "v6" || !t) && Mh.test(e));
}
class Re extends k {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== v.string) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.string,
        received: s.parsedType
      }), R;
    }
    const n = new re();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), y(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), y(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, o = t.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(t, a), i ? y(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && y(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        kh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "email",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        Ka || (Ka = new RegExp(Ph, "u")), Ka.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "emoji",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        Ch.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "uuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        Ih.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "nanoid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        Eh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "cuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        Rh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "cuid2",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        wh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "ulid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), y(a, {
            validation: "url",
            code: p.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "regex",
        code: p.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? Lh(s).test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? Dh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? Hh(s).test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? Oh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "duration",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? Uh(t.data, s.version) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "ip",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? Kh(t.data, s.alg) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "jwt",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? Bh(t.data, s.version) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "cidr",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? Nh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "base64",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? jh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "base64url",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : V.assertNever(s);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: p.invalid_string,
      ...g.errToObj(n)
    });
  }
  _addCheck(t) {
    return new Re({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...g.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...g.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...g.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...g.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...g.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...g.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...g.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...g.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...g.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...g.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...g.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...g.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...g.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...g.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...g.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...g.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...g.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...g.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...g.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...g.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...g.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...g.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...g.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, g.errToObj(t));
  }
  trim() {
    return new Re({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Re({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Re({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Re.create = (e) => new Re({
  checks: [],
  typeName: T.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...w(e)
});
function Gh(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, s = Number.parseInt(e.toFixed(a).replace(".", "")), i = Number.parseInt(t.toFixed(a).replace(".", ""));
  return s % i / 10 ** a;
}
class _t extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== v.number) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.number,
        received: s.parsedType
      }), R;
    }
    let n;
    const a = new re();
    for (const s of this._def.checks)
      s.kind === "int" ? V.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? Gh(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_finite,
        message: s.message
      }), a.dirty()) : V.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, g.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, g.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, g.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, g.toString(r));
  }
  setLimit(t, r, n, a) {
    return new _t({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new _t({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: g.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: g.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: g.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: g.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: g.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: g.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: g.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: g.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: g.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && V.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
_t.create = (e) => new _t({
  checks: [],
  typeName: T.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...w(e)
});
class Mt extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== v.bigint)
      return this._getInvalidInput(t);
    let n;
    const a = new re();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : V.assertNever(s);
    return { status: a.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return y(r, {
      code: p.invalid_type,
      expected: v.bigint,
      received: r.parsedType
    }), R;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, g.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, g.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, g.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, g.toString(r));
  }
  setLimit(t, r, n, a) {
    return new Mt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Mt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: g.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Mt.create = (e) => new Mt({
  checks: [],
  typeName: T.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...w(e)
});
class cs extends k {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== v.boolean) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.boolean,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
cs.create = (e) => new cs({
  typeName: T.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...w(e)
});
class nr extends k {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== v.date) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.date,
        received: s.parsedType
      }), R;
    }
    if (Number.isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_date
      }), R;
    }
    const n = new re();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : V.assertNever(s);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new nr({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: g.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: g.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
nr.create = (e) => new nr({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: T.ZodDate,
  ...w(e)
});
class Su extends k {
  _parse(t) {
    if (this._getType(t) !== v.symbol) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.symbol,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
Su.create = (e) => new Su({
  typeName: T.ZodSymbol,
  ...w(e)
});
class ls extends k {
  _parse(t) {
    if (this._getType(t) !== v.undefined) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.undefined,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
ls.create = (e) => new ls({
  typeName: T.ZodUndefined,
  ...w(e)
});
class ds extends k {
  _parse(t) {
    if (this._getType(t) !== v.null) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.null,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
ds.create = (e) => new ds({
  typeName: T.ZodNull,
  ...w(e)
});
class Nt extends k {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return le(t.data);
  }
}
Nt.create = (e) => new Nt({
  typeName: T.ZodAny,
  ...w(e)
});
class Au extends k {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return le(t.data);
  }
}
Au.create = (e) => new Au({
  typeName: T.ZodUnknown,
  ...w(e)
});
class Me extends k {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return y(r, {
      code: p.invalid_type,
      expected: v.never,
      received: r.parsedType
    }), R;
  }
}
Me.create = (e) => new Me({
  typeName: T.ZodNever,
  ...w(e)
});
class Tu extends k {
  _parse(t) {
    if (this._getType(t) !== v.undefined) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.void,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
Tu.create = (e) => new Tu({
  typeName: T.ZodVoid,
  ...w(e)
});
class he extends k {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== v.array)
      return y(r, {
        code: p.invalid_type,
        expected: v.array,
        received: r.parsedType
      }), R;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (y(r, {
        code: i ? p.too_big : p.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (y(r, {
      code: p.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (y(r, {
      code: p.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new pe(r, i, r.path, o)))).then((i) => re.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new pe(r, i, r.path, o)));
    return re.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new he({
      ...this._def,
      minLength: { value: t, message: g.toString(r) }
    });
  }
  max(t, r) {
    return new he({
      ...this._def,
      maxLength: { value: t, message: g.toString(r) }
    });
  }
  length(t, r) {
    return new he({
      ...this._def,
      exactLength: { value: t, message: g.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
he.create = (e, t) => new he({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: T.ZodArray,
  ...w(t)
});
function ft(e) {
  if (e instanceof W) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = we.create(ft(n));
    }
    return new W({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof he ? new he({
    ...e._def,
    type: ft(e.element)
  }) : e instanceof we ? we.create(ft(e.unwrap())) : e instanceof Xe ? Xe.create(ft(e.unwrap())) : e instanceof ze ? ze.create(e.items.map((t) => ft(t))) : e;
}
class W extends k {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = V.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== v.object) {
      const l = this._getOrReturnCtx(t);
      return y(l, {
        code: p.invalid_type,
        expected: v.object,
        received: l.parsedType
      }), R;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Me && this._def.unknownKeys === "strip"))
      for (const l in a.data)
        i.includes(l) || o.push(l);
    const c = [];
    for (const l of i) {
      const h = s[l], m = a.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: h._parse(new pe(a, m, a.path, l)),
        alwaysSet: l in a.data
      });
    }
    if (this._def.catchall instanceof Me) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const h of o)
          c.push({
            key: { status: "valid", value: h },
            value: { status: "valid", value: a.data[h] }
          });
      else if (l === "strict")
        o.length > 0 && (y(a, {
          code: p.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const h of o) {
        const m = a.data[h];
        c.push({
          key: { status: "valid", value: h },
          value: l._parse(
            new pe(a, m, a.path, h)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: h in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const h of c) {
        const m = await h.key, E = await h.value;
        l.push({
          key: m,
          value: E,
          alwaysSet: h.alwaysSet
        });
      }
      return l;
    }).then((l) => re.mergeObjectSync(n, l)) : re.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return g.errToObj, new W({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var s, i;
          const a = ((i = (s = this._def).errorMap) == null ? void 0 : i.call(s, r, n).message) ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: g.errToObj(t).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new W({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new W({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new W({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new W({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: T.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new W({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of V.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new W({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of V.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new W({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ft(this);
  }
  partial(t) {
    const r = {};
    for (const n of V.objectKeys(this.shape)) {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }
    return new W({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of V.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof we; )
          s = s._def.innerType;
        r[n] = s;
      }
    return new W({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Cc(V.objectKeys(this.shape));
  }
}
W.create = (e, t) => new W({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Me.create(),
  typeName: T.ZodObject,
  ...w(t)
});
W.strictCreate = (e, t) => new W({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Me.create(),
  typeName: T.ZodObject,
  ...w(t)
});
W.lazycreate = (e, t) => new W({
  shape: e,
  unknownKeys: "strip",
  catchall: Me.create(),
  typeName: T.ZodObject,
  ...w(t)
});
class ar extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new Ce(o.ctx.common.issues));
      return y(r, {
        code: p.invalid_union,
        unionErrors: i
      }), R;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const c of n) {
        const l = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, h = c._parseSync({
          data: r.data,
          path: r.path,
          parent: l
        });
        if (h.status === "valid")
          return h;
        h.status === "dirty" && !s && (s = { result: h, ctx: l }), l.common.issues.length && i.push(l.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((c) => new Ce(c));
      return y(r, {
        code: p.invalid_union,
        unionErrors: o
      }), R;
    }
  }
  get options() {
    return this._def.options;
  }
}
ar.create = (e, t) => new ar({
  options: e,
  typeName: T.ZodUnion,
  ...w(t)
});
const Ee = (e) => e instanceof or ? Ee(e.schema) : e instanceof Ye ? Ee(e.innerType()) : e instanceof ur ? [e.value] : e instanceof Qe ? e.options : e instanceof hs ? V.objectValues(e.enum) : e instanceof lr ? Ee(e._def.innerType) : e instanceof ls ? [void 0] : e instanceof ds ? [null] : e instanceof we ? [void 0, ...Ee(e.unwrap())] : e instanceof Xe ? [null, ...Ee(e.unwrap())] : e instanceof Ic || e instanceof fr ? Ee(e.unwrap()) : e instanceof dr ? Ee(e._def.innerType) : [];
class Os extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== v.object)
      return y(r, {
        code: p.invalid_type,
        expected: v.object,
        received: r.parsedType
      }), R;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (y(r, {
      code: p.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), R);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = Ee(s.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new Os({
      typeName: T.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ...w(n)
    });
  }
}
function fs(e, t) {
  const r = qe(e), n = qe(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === v.object && n === v.object) {
    const a = V.objectKeys(t), s = V.objectKeys(e).filter((o) => a.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of s) {
      const c = fs(e[o], t[o]);
      if (!c.valid)
        return { valid: !1 };
      i[o] = c.data;
    }
    return { valid: !0, data: i };
  } else if (r === v.array && n === v.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s], o = t[s], c = fs(i, o);
      if (!c.valid)
        return { valid: !1 };
      a.push(c.data);
    }
    return { valid: !0, data: a };
  } else return r === v.date && n === v.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class sr extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (s, i) => {
      if (gu(s) || gu(i))
        return R;
      const o = fs(s.value, i.value);
      return o.valid ? ((_u(s) || _u(i)) && r.dirty(), { status: r.value, value: o.data }) : (y(n, {
        code: p.invalid_intersection_types
      }), R);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
sr.create = (e, t, r) => new sr({
  left: e,
  right: t,
  typeName: T.ZodIntersection,
  ...w(r)
});
class ze extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.array)
      return y(n, {
        code: p.invalid_type,
        expected: v.array,
        received: n.parsedType
      }), R;
    if (n.data.length < this._def.items.length)
      return y(n, {
        code: p.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), R;
    !this._def.rest && n.data.length > this._def.items.length && (y(n, {
      code: p.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new pe(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => re.mergeArray(r, i)) : re.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new ze({
      ...this._def,
      rest: t
    });
  }
}
ze.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ze({
    items: e,
    typeName: T.ZodTuple,
    rest: null,
    ...w(t)
  });
};
class ir extends k {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.object)
      return y(n, {
        code: p.invalid_type,
        expected: v.object,
        received: n.parsedType
      }), R;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new pe(n, o, n.path, o)),
        value: i._parse(new pe(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? re.mergeObjectAsync(r, a) : re.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof k ? new ir({
      keyType: t,
      valueType: r,
      typeName: T.ZodRecord,
      ...w(n)
    }) : new ir({
      keyType: Re.create(),
      valueType: t,
      typeName: T.ZodRecord,
      ...w(r)
    });
  }
}
class Eu extends k {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.map)
      return y(n, {
        code: p.invalid_type,
        expected: v.map,
        received: n.parsedType
      }), R;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, c], l) => ({
      key: a._parse(new pe(n, o, n.path, [l, "key"])),
      value: s._parse(new pe(n, c, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of i) {
          const l = await c.key, h = await c.value;
          if (l.status === "aborted" || h.status === "aborted")
            return R;
          (l.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(l.value, h.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of i) {
        const l = c.key, h = c.value;
        if (l.status === "aborted" || h.status === "aborted")
          return R;
        (l.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(l.value, h.value);
      }
      return { status: r.value, value: o };
    }
  }
}
Eu.create = (e, t, r) => new Eu({
  valueType: t,
  keyType: e,
  typeName: T.ZodMap,
  ...w(r)
});
class jt extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.set)
      return y(n, {
        code: p.invalid_type,
        expected: v.set,
        received: n.parsedType
      }), R;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (y(n, {
      code: p.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (y(n, {
      code: p.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(c) {
      const l = /* @__PURE__ */ new Set();
      for (const h of c) {
        if (h.status === "aborted")
          return R;
        h.status === "dirty" && r.dirty(), l.add(h.value);
      }
      return { status: r.value, value: l };
    }
    const o = [...n.data.values()].map((c, l) => s._parse(new pe(n, c, n.path, l)));
    return n.common.async ? Promise.all(o).then((c) => i(c)) : i(o);
  }
  min(t, r) {
    return new jt({
      ...this._def,
      minSize: { value: t, message: g.toString(r) }
    });
  }
  max(t, r) {
    return new jt({
      ...this._def,
      maxSize: { value: t, message: g.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
jt.create = (e, t) => new jt({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: T.ZodSet,
  ...w(t)
});
class or extends k {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
or.create = (e, t) => new or({
  getter: e,
  typeName: T.ZodLazy,
  ...w(t)
});
class ur extends k {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return y(r, {
        received: r.data,
        code: p.invalid_literal,
        expected: this._def.value
      }), R;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
ur.create = (e, t) => new ur({
  value: e,
  typeName: T.ZodLiteral,
  ...w(t)
});
function Cc(e, t) {
  return new Qe({
    values: e,
    typeName: T.ZodEnum,
    ...w(t)
  });
}
class Qe extends k {
  constructor() {
    super(...arguments), Vt.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return y(r, {
        expected: V.joinValues(n),
        received: r.parsedType,
        code: p.invalid_type
      }), R;
    }
    if (rr(this, Vt, "f") || Ec(this, Vt, new Set(this._def.values), "f"), !rr(this, Vt, "f").has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return y(r, {
        received: r.data,
        code: p.invalid_enum_value,
        options: n
      }), R;
    }
    return le(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return Qe.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return Qe.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Vt = /* @__PURE__ */ new WeakMap();
Qe.create = Cc;
class hs extends k {
  constructor() {
    super(...arguments), $t.set(this, void 0);
  }
  _parse(t) {
    const r = V.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== v.string && n.parsedType !== v.number) {
      const a = V.objectValues(r);
      return y(n, {
        expected: V.joinValues(a),
        received: n.parsedType,
        code: p.invalid_type
      }), R;
    }
    if (rr(this, $t, "f") || Ec(this, $t, new Set(V.getValidEnumValues(this._def.values)), "f"), !rr(this, $t, "f").has(t.data)) {
      const a = V.objectValues(r);
      return y(n, {
        received: n.data,
        code: p.invalid_enum_value,
        options: a
      }), R;
    }
    return le(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
$t = /* @__PURE__ */ new WeakMap();
hs.create = (e, t) => new hs({
  values: e,
  typeName: T.ZodNativeEnum,
  ...w(t)
});
class cr extends k {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== v.promise && r.common.async === !1)
      return y(r, {
        code: p.invalid_type,
        expected: v.promise,
        received: r.parsedType
      }), R;
    const n = r.parsedType === v.promise ? r.data : Promise.resolve(r.data);
    return le(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
cr.create = (e, t) => new cr({
  type: e,
  typeName: T.ZodPromise,
  ...w(t)
});
class Ye extends k {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === T.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (i) => {
        y(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return R;
          const c = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return c.status === "aborted" ? R : c.status === "dirty" || r.value === "dirty" ? qt(c.value) : c;
        });
      {
        if (r.value === "aborted")
          return R;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? R : o.status === "dirty" || r.value === "dirty" ? qt(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const c = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? R : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? R : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!gt(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => gt(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({
          status: r.value,
          value: o
        })) : i);
    V.assertNever(a);
  }
}
Ye.create = (e, t, r) => new Ye({
  schema: e,
  typeName: T.ZodEffects,
  effect: t,
  ...w(r)
});
Ye.createWithPreprocess = (e, t, r) => new Ye({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: T.ZodEffects,
  ...w(r)
});
class we extends k {
  _parse(t) {
    return this._getType(t) === v.undefined ? le(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
we.create = (e, t) => new we({
  innerType: e,
  typeName: T.ZodOptional,
  ...w(t)
});
class Xe extends k {
  _parse(t) {
    return this._getType(t) === v.null ? le(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Xe.create = (e, t) => new Xe({
  innerType: e,
  typeName: T.ZodNullable,
  ...w(t)
});
class lr extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === v.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
lr.create = (e, t) => new lr({
  innerType: e,
  typeName: T.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...w(t)
});
class dr extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return tr(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Ce(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Ce(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
dr.create = (e, t) => new dr({
  innerType: e,
  typeName: T.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...w(t)
});
class Ru extends k {
  _parse(t) {
    if (this._getType(t) !== v.nan) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.nan,
        received: n.parsedType
      }), R;
    }
    return { status: "valid", value: t.data };
  }
}
Ru.create = (e) => new Ru({
  typeName: T.ZodNaN,
  ...w(e)
});
class Ic extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ks extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? R : s.status === "dirty" ? (r.dirty(), qt(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? R : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new ks({
      in: t,
      out: r,
      typeName: T.ZodPipeline
    });
  }
}
class fr extends k {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (a) => (gt(a) && (a.value = Object.freeze(a.value)), a);
    return tr(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
fr.create = (e, t) => new fr({
  innerType: e,
  typeName: T.ZodReadonly,
  ...w(t)
});
function wu(e, t) {
  const r = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof r == "string" ? { message: r } : r;
}
function Ps(e, t = {}, r) {
  return e ? Nt.create().superRefine((n, a) => {
    const s = e(n);
    if (s instanceof Promise)
      return s.then((i) => {
        if (!i) {
          const o = wu(t, n), c = o.fatal ?? r ?? !0;
          a.addIssue({ code: "custom", ...o, fatal: c });
        }
      });
    if (!s) {
      const i = wu(t, n), o = i.fatal ?? r ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: o });
    }
  }) : Nt.create();
}
var T;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(T || (T = {}));
const wr = (e, t = {
  message: `Input not instance of ${e.name}`
}) => Ps((r) => r instanceof e, t), u = Re.create, wt = _t.create, C = cs.create;
Nt.create;
Me.create;
const S = he.create, f = W.create, U = ar.create, K = Os.create;
sr.create;
ze.create;
const Fh = ir.create, de = or.create, d = ur.create, ne = Qe.create;
cr.create;
const ce = we.create;
Xe.create;
var A = (e) => e, Zh = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null) return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Type guard that checks if data is valid for any version up to and including the specified version.
   * 
   * @param data The data to check
   * @param upToVersion The maximum version to check against (inclusive)
   * @returns true if the data is valid for any version from 1 to upToVersion,
   *          false if the data's version is higher than upToVersion or invalid
   * 
   * @example
   * ```ts
   * const entity = createVersionedEntity({ ... })
   * 
   * if (entity.isUpToVersion(data, 2)) {
   *   // data is guaranteed to be v1 or v2 (but not v3 or higher)
   * }
   * 
   * // Returns false for v3 data when checking up to v2
   * entity.isUpToVersion(v3Data, 2) // false
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions where you want to ensure
   * nested entities are at a specific version or lower.
   */
  isUpToVersion(e, t) {
    let r = this.getVersion(e);
    if (r === null || r > t) return !1;
    const n = this.versionMap[r];
    return n ? n.schema.safeParse(e).success : !1;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let a = n.data;
    for (let s = t + 1; s <= this.latestVersion; s++) {
      const i = this.versionMap[s];
      if (!i)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: s }
        };
      if (i.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: s }
        };
      a = i.up(a);
    }
    return { type: "ok", value: a };
  }
  /**
   * Returns the Zod schema for the latest version of the entity.
   * 
   * @example
   * ```ts
   * const UserEntity = createVersionedEntity({ ... })
   * const latestSchema = UserEntity.latestSchema
   * ```
   */
  get latestSchema() {
    return this.versionMap[this.latestVersion].schema;
  }
  /**
   * Parses data and migrates it up to a specific version (not beyond).
   * 
   * @param data The data to parse and potentially migrate
   * @param version The target version to migrate to (will not migrate beyond this)
   * @returns A ParseResult containing either the migrated data or an error.
   *          Returns { type: "err", error: { type: "INVALID_VER" } } if data version is higher than requested.
   * 
   * @example
   * ```ts
   * // If you have v1 data and versions up to v4 exist:
   * const result = entity.safeParseUpToVersion(v1Data, 2)
   * // result will contain v2 data (not v3 or v4)
   * 
   * // Trying to parse v3 data up to v2 returns an error
   * const result = entity.safeParseUpToVersion(v3Data, 2)
   * // result: { type: "err", error: { type: "INVALID_VER" } }
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions to prevent migration
   * functions from receiving future versions they weren't designed to handle.
   */
  safeParseUpToVersion(e, t) {
    const r = this.getVersion(e);
    if (r === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    if (r > t)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = this.versionMap[r];
    if (!n)
      return { type: "err", error: { type: "INVALID_VER" } };
    const a = n.schema.safeParse(e);
    if (!a.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: r,
          versionDef: n,
          error: a.error
        }
      };
    let s = a.data;
    for (let i = r + 1; i <= t; i++) {
      const o = this.versionMap[i];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: i }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: i }
        };
      s = o.up(s);
    }
    return { type: "ok", value: s };
  }
};
function tt(e) {
  return new Zh(e.versionMap, e.latestVersion, e.getVersion);
}
function bt(e) {
  return Ps((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
function ve(e, t) {
  return Ps((r) => e.isUpToVersion(r, t)).transform((r) => {
    const n = e.safeParseUpToVersion(r, t);
    if (n.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.isUpToVersion` returned success, safeParse failed."
      );
    return n.value;
  });
}
var Ba, Cu;
function Wh() {
  if (Cu) return Ba;
  Cu = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return Ba = t, Ba;
}
var Ga, Iu;
function Jh() {
  if (Iu) return Ga;
  Iu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Ga = e, Ga;
}
var Fa, xu;
function zh() {
  if (xu) return Fa;
  xu = 1;
  var e = uc(), t = Wh(), r = Jh();
  function n(a) {
    var s = -1, i = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++s < i; )
      this.add(a[s]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Fa = n, Fa;
}
var Za, Ou;
function Qh() {
  if (Ou) return Za;
  Ou = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Za = e, Za;
}
var Wa, ku;
function Yh() {
  if (ku) return Wa;
  ku = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Wa = e, Wa;
}
var Ja, Pu;
function xc() {
  if (Pu) return Ja;
  Pu = 1;
  var e = zh(), t = Qh(), r = Yh(), n = 1, a = 2;
  function s(i, o, c, l, h, m) {
    var E = c & n, j = i.length, Z = o.length;
    if (j != Z && !(E && Z > j))
      return !1;
    var D = m.get(i), M = m.get(o);
    if (D && M)
      return D == o && M == i;
    var $ = -1, I = !0, B = c & a ? new e() : void 0;
    for (m.set(i, o), m.set(o, i); ++$ < j; ) {
      var P = i[$], G = o[$];
      if (l)
        var q = E ? l(G, P, $, o, i, m) : l(P, G, $, i, o, m);
      if (q !== void 0) {
        if (q)
          continue;
        I = !1;
        break;
      }
      if (B) {
        if (!t(o, function(O, J) {
          if (!r(B, J) && (P === O || h(P, O, c, l, m)))
            return B.push(J);
        })) {
          I = !1;
          break;
        }
      } else if (!(P === G || h(P, G, c, l, m))) {
        I = !1;
        break;
      }
    }
    return m.delete(i), m.delete(o), I;
  }
  return Ja = s, Ja;
}
var za, qu;
function Xh() {
  if (qu) return za;
  qu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, s) {
      n[++r] = [s, a];
    }), n;
  }
  return za = e, za;
}
var Qa, Vu;
function ep() {
  if (Vu) return Qa;
  Vu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return Qa = e, Qa;
}
var Ya, $u;
function tp() {
  if ($u) return Ya;
  $u = 1;
  var e = _r(), t = Tc(), r = bs(), n = xc(), a = Xh(), s = ep(), i = 1, o = 2, c = "[object Boolean]", l = "[object Date]", h = "[object Error]", m = "[object Map]", E = "[object Number]", j = "[object RegExp]", Z = "[object Set]", D = "[object String]", M = "[object Symbol]", $ = "[object ArrayBuffer]", I = "[object DataView]", B = e ? e.prototype : void 0, P = B ? B.valueOf : void 0;
  function G(q, O, J, H, ae, x, te) {
    switch (J) {
      case I:
        if (q.byteLength != O.byteLength || q.byteOffset != O.byteOffset)
          return !1;
        q = q.buffer, O = O.buffer;
      case $:
        return !(q.byteLength != O.byteLength || !x(new t(q), new t(O)));
      case c:
      case l:
      case E:
        return r(+q, +O);
      case h:
        return q.name == O.name && q.message == O.message;
      case j:
      case D:
        return q == O + "";
      case m:
        var ie = a;
      case Z:
        var st = H & i;
        if (ie || (ie = s), q.size != O.size && !st)
          return !1;
        var it = te.get(q);
        if (it)
          return it == O;
        H |= o, te.set(q, O);
        var Kr = n(ie(q), ie(O), H, ae, x, te);
        return te.delete(q), Kr;
      case M:
        if (P)
          return P.call(q) == P.call(O);
    }
    return !1;
  }
  return Ya = G, Ya;
}
var Xa, Mu;
function rp() {
  if (Mu) return Xa;
  Mu = 1;
  var e = Ac(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o, c, l, h) {
    var m = o & t, E = e(s), j = E.length, Z = e(i), D = Z.length;
    if (j != D && !m)
      return !1;
    for (var M = j; M--; ) {
      var $ = E[M];
      if (!(m ? $ in i : n.call(i, $)))
        return !1;
    }
    var I = h.get(s), B = h.get(i);
    if (I && B)
      return I == i && B == s;
    var P = !0;
    h.set(s, i), h.set(i, s);
    for (var G = m; ++M < j; ) {
      $ = E[M];
      var q = s[$], O = i[$];
      if (c)
        var J = m ? c(O, q, $, i, s, h) : c(q, O, $, s, i, h);
      if (!(J === void 0 ? q === O || l(q, O, o, c, h) : J)) {
        P = !1;
        break;
      }
      G || (G = $ == "constructor");
    }
    if (P && !G) {
      var H = s.constructor, ae = i.constructor;
      H != ae && "constructor" in s && "constructor" in i && !(typeof H == "function" && H instanceof H && typeof ae == "function" && ae instanceof ae) && (P = !1);
    }
    return h.delete(s), h.delete(i), P;
  }
  return Xa = a, Xa;
}
var es, Nu;
function np() {
  if (Nu) return es;
  Nu = 1;
  var e = cc(), t = xc(), r = tp(), n = rp(), a = Rr(), s = Er(), i = As(), o = hc(), c = 1, l = "[object Arguments]", h = "[object Array]", m = "[object Object]", E = Object.prototype, j = E.hasOwnProperty;
  function Z(D, M, $, I, B, P) {
    var G = s(D), q = s(M), O = G ? h : a(D), J = q ? h : a(M);
    O = O == l ? m : O, J = J == l ? m : J;
    var H = O == m, ae = J == m, x = O == J;
    if (x && i(D)) {
      if (!i(M))
        return !1;
      G = !0, H = !1;
    }
    if (x && !H)
      return P || (P = new e()), G || o(D) ? t(D, M, $, I, B, P) : r(D, M, O, $, I, B, P);
    if (!($ & c)) {
      var te = H && j.call(D, "__wrapped__"), ie = ae && j.call(M, "__wrapped__");
      if (te || ie) {
        var st = te ? D.value() : D, it = ie ? M.value() : M;
        return P || (P = new e()), B(st, it, $, I, P);
      }
    }
    return x ? (P || (P = new e()), n(D, M, $, I, B, P)) : !1;
  }
  return es = Z, es;
}
var ts, ju;
function ap() {
  if (ju) return ts;
  ju = 1;
  var e = np(), t = Rt();
  function r(n, a, s, i, o) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, s, i, r, o);
  }
  return ts = r, ts;
}
var rs, Du;
function sp() {
  if (Du) return rs;
  Du = 1;
  var e = ap();
  function t(r, n) {
    return e(r, n);
  }
  return rs = t, rs;
}
var ip = sp();
const op = /* @__PURE__ */ ac(ip), up = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), ns = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), lt = {
  equals(e, t) {
    return op(e, t);
  }
}, cp = f({
  id: ce(u()),
  // Firebase Firestore ID
  url: u(),
  path: u(),
  headers: S(
    f({
      key: u(),
      value: u(),
      active: C()
    })
  ),
  params: S(
    f({
      key: u(),
      value: u(),
      active: C()
    })
  ),
  name: u(),
  method: u(),
  preRequestScript: u(),
  testScript: u(),
  contentType: u(),
  body: u(),
  rawParams: ce(u()),
  auth: ce(u()),
  httpUser: ce(u()),
  httpPassword: ce(u()),
  bearerToken: ce(u())
}), Hu = A({
  initial: !0,
  schema: cp
}), qs = f({
  key: u(),
  active: C()
}).and(
  U([
    f({
      isFile: d(!0),
      value: S(wr(Blob).nullable())
    }),
    f({
      isFile: d(!1),
      value: u()
    })
  ])
);
f({
  contentType: d("multipart/form-data"),
  body: S(qs)
});
const lp = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: S(qs).catch([])
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), ge = f({
  authType: d("none")
}), _e = f({
  authType: d("basic"),
  username: u().catch(""),
  password: u().catch("")
}), be = f({
  authType: d("bearer"),
  token: u().catch("")
}), dp = f({
  authType: d("oauth-2"),
  token: u().catch(""),
  oidcDiscoveryURL: u().catch(""),
  authURL: u().catch(""),
  accessTokenURL: u().catch(""),
  clientID: u().catch(""),
  scope: u().catch("")
}), Vs = f({
  authType: d("api-key"),
  key: u().catch(""),
  value: u().catch(""),
  addTo: u().catch("Headers")
}), Se = f({
  authType: d("inherit")
}), fp = K("authType", [
  ge,
  Se,
  _e,
  be,
  dp,
  Vs
]).and(
  f({
    authActive: C()
  })
), hp = S(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: C().catch(!0)
  })
), Oc = S(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: C().catch(!0)
  })
), kc = f({
  v: d("1"),
  id: ce(u()),
  // Firebase Firestore ID
  name: u(),
  method: u(),
  endpoint: u(),
  params: hp,
  headers: Oc,
  preRequestScript: u().catch(""),
  testScript: u().catch(""),
  auth: fp,
  body: lp
});
function pp(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function yp(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const mp = A({
  initial: !1,
  schema: kc,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: c
    } = e, l = `${t}${r}`, h = pp(e), m = yp(e), E = {
      v: "1",
      endpoint: l,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: c,
      body: h,
      auth: m
    };
    return e.id && (E.id = e.id), E;
  }
}), $s = S(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: C().catch(!0)
  })
), Pc = kc.extend({
  v: d("2"),
  requestVariables: $s
}), vp = A({
  initial: !1,
  schema: Pc,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), qc = f({
  grantType: d("AUTHORIZATION_CODE"),
  authEndpoint: u().trim(),
  tokenEndpoint: u().trim(),
  clientID: u().trim(),
  clientSecret: u().trim(),
  scopes: u().trim().optional(),
  token: u().catch(""),
  isPKCE: C(),
  codeVerifierMethod: U([d("plain"), d("S256")]).optional()
}), Cr = f({
  grantType: d("CLIENT_CREDENTIALS"),
  authEndpoint: u().trim(),
  clientID: u().trim(),
  clientSecret: u().trim(),
  scopes: u().trim().optional(),
  token: u().catch("")
}), Ir = f({
  grantType: d("PASSWORD"),
  authEndpoint: u().trim(),
  clientID: u().trim(),
  clientSecret: u().trim(),
  scopes: u().trim().optional(),
  username: u().trim(),
  password: u().trim(),
  token: u().catch("")
}), Ct = f({
  grantType: d("IMPLICIT"),
  authEndpoint: u().trim(),
  clientID: u().trim(),
  scopes: u().trim().optional(),
  token: u().catch("")
}), xr = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    qc,
    Cr,
    Ir,
    Ct
  ]),
  addTo: ne(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), gp = K("authType", [
  ge,
  Se,
  _e,
  be,
  xr,
  Vs
]).and(
  f({
    authActive: C()
  })
), Vc = Pc.extend({
  v: d("3"),
  auth: gp
}), _p = A({
  initial: !1,
  schema: Vc,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), De = Vs.extend({
  addTo: ne(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), bp = K("authType", [
  ge,
  Se,
  _e,
  be,
  xr,
  De
]).and(
  f({
    authActive: C()
  })
), $c = Vc.extend({
  v: d("4"),
  auth: bp
}), Sp = A({
  schema: $c,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), Mc = qc.extend({
  clientSecret: u().optional()
}), Or = xr.extend({
  grantTypeInfo: K("grantType", [
    Mc,
    Cr,
    Ir,
    Ct
  ])
}), Nc = K("authType", [
  ge,
  Se,
  _e,
  be,
  Or,
  De
]).and(
  f({
    authActive: C()
  })
), jc = $c.extend({
  v: d("5"),
  auth: Nc
}), Ap = A({
  schema: jc,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Dc = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: S(qs).catch([])
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), Hc = jc.extend({
  v: d("6"),
  body: Dc
}), Tp = A({
  schema: Hc,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), kr = Mc.extend({
  refreshToken: u().optional()
}), Lc = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    kr,
    Cr,
    Ir,
    Ct
  ]),
  addTo: ne(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ms = S(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: C().catch(!0),
    description: u().catch("")
  })
), Pr = S(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: C().catch(!0),
    description: u().catch("")
  })
), rt = f({
  authType: d("aws-signature"),
  accessKey: u().catch(""),
  secretKey: u().catch(""),
  region: u().catch(""),
  serviceName: u().catch(""),
  serviceToken: u().optional(),
  signature: f({}).optional(),
  addTo: ne(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Uc = K("authType", [
  ge,
  Se,
  _e,
  be,
  Lc,
  De,
  rt
]).and(
  f({
    authActive: C()
  })
), Kc = Hc.extend({
  v: d("7"),
  params: Ms,
  headers: Pr,
  auth: Uc
}), Ep = A({
  schema: Kc,
  initial: !1,
  up(e) {
    const t = e.params.map((n) => ({
      ...n,
      description: ""
    })), r = e.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...e,
      v: "7",
      params: t,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), Bc = Cr.extend({
  clientSecret: u().optional()
}), Ns = Ir.extend({
  clientSecret: u().optional()
}), Rp = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    kr,
    Bc,
    Ns,
    Ct
  ]),
  addTo: ne(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ut = f({
  authType: d("digest"),
  username: u().catch(""),
  password: u().catch(""),
  realm: u().catch(""),
  nonce: u().catch(""),
  algorithm: ne(["MD5", "MD5-sess"]).catch("MD5"),
  qop: ne(["auth", "auth-int"]).catch("auth"),
  nc: u().catch(""),
  cnonce: u().catch(""),
  opaque: u().catch(""),
  disableRetry: C().catch(!1)
}), js = K("authType", [
  ge,
  Se,
  _e,
  be,
  Rp,
  De,
  rt,
  Ut
]).and(
  f({
    authActive: C()
  })
), Gc = f({
  v: d("1"),
  name: u(),
  method: u(),
  endpoint: u(),
  headers: Pr,
  params: Ms,
  body: Dc,
  auth: js,
  requestVariables: $s
}), Lu = A({
  initial: !0,
  schema: Gc
}), Fc = f({
  key: u(),
  active: C(),
  contentType: u().optional().catch(void 0)
}).and(
  U([
    f({
      isFile: d(!0),
      value: S(wr(Blob).nullable()).catch([])
    }),
    f({
      isFile: d(!1),
      value: u()
    })
  ])
).transform((e) => e.isFile && Array.isArray(e.value) && e.value.length === 0 ? {
  ...e,
  isFile: !1,
  value: ""
} : e), Zc = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: S(Fc).catch([]),
    showIndividualContentType: C().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: wr(File).nullable().catch(null)
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), Wc = Gc.extend({
  v: d("2"),
  body: Zc
}), wp = A({
  initial: !1,
  schema: Wc,
  up(e) {
    return {
      ...e,
      v: "2"
    };
  }
}), Jc = Bc.extend({
  clientAuthentication: ne(["AS_BASIC_AUTH_HEADERS", "IN_BODY"])
}), qr = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    kr,
    Jc,
    Ns,
    Ct
  ]),
  addTo: ne(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ds = K("authType", [
  ge,
  Se,
  _e,
  be,
  qr,
  De,
  rt,
  Ut
]).and(
  f({
    authActive: C()
  })
), Hs = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: S(Fc).catch([]),
    showIndividualContentType: C().optional().catch(!1),
    isBulkEditing: C().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: wr(File).nullable().catch(null)
  }),
  f({
    contentType: d("application/x-www-form-urlencoded"),
    body: u().catch(""),
    isBulkEditing: C().optional().catch(!1)
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), zc = Wc.extend({
  v: d("3"),
  auth: Ds,
  body: Hs
}), Cp = A({
  initial: !1,
  schema: zc,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "3",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), Ls = f({
  authType: d("hawk"),
  authId: u().catch(""),
  authKey: u().catch(""),
  algorithm: ne(["sha256", "sha1"]).catch("sha256"),
  includePayloadHash: C().catch(!1),
  // Optional fields
  user: u().optional(),
  nonce: u().optional(),
  ext: u().optional(),
  app: u().optional(),
  dlg: u().optional(),
  timestamp: u().optional()
}), Us = f({
  authType: d("akamai-eg"),
  accessToken: u().catch(""),
  clientToken: u().catch(""),
  clientSecret: u().catch(""),
  // Optional fields
  nonce: u().optional(),
  timestamp: u().optional(),
  host: u().optional(),
  headersToSign: u().optional(),
  maxBodySize: u().optional()
}), Ks = K("authType", [
  ge,
  Se,
  _e,
  be,
  qr,
  De,
  rt,
  Ut,
  Ls,
  Us
]).and(
  f({
    authActive: C()
  })
), Qc = zc.extend({
  v: d("4"),
  auth: Ks
}), Ip = A({
  initial: !1,
  schema: Qc,
  up(e) {
    return {
      ...e,
      v: "4"
    };
  }
}), Yc = f({
  authType: d("jwt"),
  secret: u().catch(""),
  privateKey: u().catch(""),
  // For RSA/ECDSA algorithms
  algorithm: ne([
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
  ]).catch("HS256"),
  payload: u().catch("{}"),
  addTo: ne(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS"),
  isSecretBase64Encoded: C().catch(!1),
  headerPrefix: u().catch("Bearer "),
  paramName: u().catch("token"),
  jwtHeaders: u().catch("{}")
}), Bs = K("authType", [
  ge,
  Se,
  _e,
  be,
  qr,
  De,
  rt,
  Ut,
  Ls,
  Us,
  Yc
]).and(
  f({
    authActive: C()
  })
), Xc = Qc.extend({
  v: d("5"),
  auth: Bs
}), xp = A({
  initial: !1,
  schema: Xc,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Ne = f({
  id: wt(),
  key: u(),
  value: u(),
  active: C(),
  sendIn: ne(["headers", "url", "body"]).catch("headers")
}), el = Ne.omit({ sendIn: !0 }), Op = kr.extend({
  authRequestParams: S(el).optional().default([]),
  tokenRequestParams: S(Ne).optional().default([]),
  refreshRequestParams: S(Ne).optional().default([])
}), kp = Jc.extend({
  tokenRequestParams: S(Ne).optional().default([]),
  refreshRequestParams: S(Ne).optional().default([])
}), Pp = Ns.extend({
  tokenRequestParams: S(Ne).optional().default([]),
  refreshRequestParams: S(Ne).optional().default([])
}), qp = Ct.extend({
  authRequestParams: S(el).optional().default([]),
  refreshRequestParams: S(Ne).optional().default([])
}), tl = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Op,
    kp,
    Pp,
    qp
  ]),
  addTo: ne(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Vr = K("authType", [
  ge,
  Se,
  _e,
  be,
  tl,
  De,
  rt,
  Ut,
  Ls,
  Us,
  Yc
]).and(
  f({
    authActive: C()
  })
), Vp = Xc.extend({
  v: d("6"),
  auth: Vr
}), $p = A({
  initial: !1,
  schema: Vp,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "6",
      auth: t
    };
  }
}), Mp = f({
  // v is a stringified number
  v: u().regex(/^\d+$/).transform(Number)
}), Np = tt({
  latestVersion: 6,
  versionMap: {
    1: Lu,
    2: wp,
    3: Cp,
    4: Ip,
    5: xp,
    6: $p
  },
  getVersion(e) {
    const t = Mp.safeParse(e);
    return t.success ? t.data.v : Lu.schema.safeParse(e).success ? 1 : null;
  }
}), jp = "6", Dp = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, Hp = U(
  Object.keys(Dp).map((e) => d(parseInt(e)))
), Lp = S(
  f({
    key: u(),
    value: u()
  })
), Up = f({
  name: u(),
  originalRequest: bt(Np),
  status: u(),
  code: ce(Hp).nullable().catch(null),
  headers: Lp,
  body: u()
}), Uu = A({
  initial: !0,
  schema: Up
}), Kp = f({
  v: wt()
}), Bp = tt({
  latestVersion: 0,
  versionMap: {
    0: Uu
  },
  getVersion(e) {
    const t = Kp.safeParse(e);
    return t.success ? t.data.v : Uu.schema.safeParse(e).success ? 0 : null;
  }
}), rl = Fh(
  u(),
  bt(Bp)
);
function og(e) {
  return {
    v: jp,
    ...e
  };
}
const nl = Kc.extend({
  v: d("8"),
  auth: js,
  responses: rl
}), Gp = A({
  schema: nl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), al = nl.extend({
  v: d("9"),
  body: Zc
}), Fp = A({
  schema: al,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "9"
    };
  }
}), sl = al.extend({
  v: d("10"),
  body: Hs
}), Zp = A({
  schema: sl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "10"
    };
  }
}), il = sl.extend({
  v: d("11"),
  auth: Ds
}), Wp = A({
  schema: il,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "11",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), ol = il.extend({
  v: d("12"),
  auth: Ks
}), Jp = A({
  schema: ol,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "12"
    };
  }
}), ul = ol.extend({
  v: d("13"),
  auth: Bs
}), zp = A({
  schema: ul,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "13"
    };
  }
}), cl = ul.extend({
  v: d("14")
}), Qp = A({
  schema: cl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "14"
    };
  }
}), Yp = cl.extend({
  v: d("15"),
  auth: Vr
}), Xp = A({
  schema: Yp,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "15",
      auth: t
    };
  }
}), ey = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, ug = Object.keys(
  ey
), ty = f({
  // v is a stringified number
  v: u().regex(/^\d+$/).transform(Number)
}), $r = tt({
  latestVersion: 15,
  versionMap: {
    0: Hu,
    1: mp,
    2: vp,
    3: _p,
    4: Sp,
    5: Ap,
    6: Tp,
    7: Ep,
    8: Gp,
    9: Fp,
    10: Zp,
    11: Wp,
    12: Jp,
    13: zp,
    14: Qp,
    15: Xp
  },
  getVersion(e) {
    const t = ty.safeParse(e);
    return t.success ? t.data.v : Hu.schema.safeParse(e).success ? 0 : null;
  }
}), ry = Ld({
  id: up(Pe),
  v: Pe,
  auth: lt,
  body: lt,
  endpoint: Pe,
  headers: ns(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    lt
  ),
  params: ns(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    lt
  ),
  method: Pe,
  name: Pe,
  preRequestScript: Pe,
  testScript: Pe,
  requestVariables: ns(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    lt
  ),
  responses: lt
}), ll = "15", cg = ry.equals;
function lg(e, t) {
  const r = bh(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = Hs.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = Vr.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = Ms.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = Pr.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = $s.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in e) {
      const n = rl.safeParse(e.responses);
      n.success && (r.responses = n.data);
    }
  }
  return r;
}
function dg(e) {
  return {
    v: ll,
    ...e
  };
}
function ny() {
  return {
    v: ll,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {}
  };
}
function fg(e) {
  return $r.isLatest(e);
}
function ay(e) {
  const t = $r.safeParse(e);
  return t.type === "ok" ? t.value : ny();
}
const Gs = f({
  key: u().catch(""),
  value: u().catch(""),
  active: C().catch(!0)
}), sy = f({
  v: d(1),
  name: u(),
  url: u(),
  headers: S(Gs).catch([]),
  query: u(),
  variables: u()
}), iy = A({
  initial: !0,
  schema: sy
}), He = f({
  authType: d("none")
}), Le = f({
  authType: d("basic"),
  username: u().catch(""),
  password: u().catch("")
}), Ue = f({
  authType: d("bearer"),
  token: u().catch("")
}), oy = f({
  authType: d("oauth-2"),
  token: u().catch(""),
  oidcDiscoveryURL: u().catch(""),
  authURL: u().catch(""),
  accessTokenURL: u().catch(""),
  clientID: u().catch(""),
  scope: u().catch("")
}), Fs = f({
  authType: d("api-key"),
  key: u().catch(""),
  value: u().catch(""),
  addTo: u().catch("Headers")
}), Ke = f({
  authType: d("inherit")
}), uy = K("authType", [
  He,
  Le,
  Ue,
  oy,
  Fs,
  Ke
]).and(
  f({
    authActive: C()
  })
), dl = f({
  id: ce(u()),
  v: d(2),
  name: u(),
  url: u(),
  headers: S(Gs).catch([]),
  query: u(),
  variables: u(),
  auth: uy
}), cy = A({
  initial: !1,
  schema: dl,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), ly = K("authType", [
  He,
  Ke,
  Le,
  Ue,
  Fs,
  xr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: C()
  })
), fl = dl.extend({
  v: d(3),
  auth: ly
}), dy = A({
  initial: !1,
  schema: fl,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), It = Fs.extend({
  addTo: ne(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), fy = K("authType", [
  He,
  Ke,
  Le,
  Ue,
  It,
  Or
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: C()
  })
), hl = fl.extend({
  v: d(4),
  auth: fy
}), hy = A({
  initial: !1,
  schema: hl,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), pl = K("authType", [
  He,
  Ke,
  Le,
  Ue,
  It,
  Or
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: C()
  })
), yl = hl.extend({
  v: d(5),
  auth: pl
}), py = A({
  initial: !1,
  schema: yl,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), Mr = rt, ml = f({
  key: u().catch(""),
  value: u().catch(""),
  active: C().catch(!0),
  description: u().catch("")
}), vl = K("authType", [
  He,
  Ke,
  Le,
  Ue,
  Or,
  It,
  Mr
]).and(
  f({
    authActive: C()
  })
), gl = yl.extend({
  v: d(6),
  auth: vl,
  headers: S(ml).catch([])
}), yy = A({
  schema: gl,
  initial: !1,
  up(e) {
    const t = e.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...e,
      v: 6,
      headers: t
    };
  }
}), _l = K("authType", [
  He,
  Ke,
  Le,
  Ue,
  Lc,
  It,
  Mr
]).and(
  f({
    authActive: C()
  })
), bl = gl.extend({
  v: d(7),
  auth: _l
}), my = A({
  schema: bl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), Nr = K("authType", [
  He,
  Ke,
  Le,
  Ue,
  qr,
  It,
  Mr
]).and(
  f({
    authActive: C()
  })
), Sl = bl.extend({
  v: d(8),
  auth: Nr
}), vy = A({
  schema: Sl,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: 8,
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), Al = K("authType", [
  He,
  Ke,
  Le,
  Ue,
  tl,
  It,
  Mr
]).and(
  f({
    authActive: C()
  })
), gy = Sl.extend({
  v: d(9),
  auth: Al
}), _y = A({
  schema: gy,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t
    };
  }
}), Tl = 9, by = f({
  v: wt()
}), Zs = tt({
  latestVersion: 9,
  versionMap: {
    1: iy,
    2: cy,
    3: dy,
    4: hy,
    5: py,
    6: yy,
    7: my,
    8: vy,
    9: _y
  },
  getVersion(e) {
    const t = by.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), Sy = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function Ay() {
  return {
    v: Tl,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: Sy,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function Ty(e) {
  const t = Zs.safeParse(e);
  return t.type === "ok" ? t.value : Ay();
}
function hg(e) {
  return {
    v: Tl,
    ...e
  };
}
const Ey = f({
  v: d(1),
  id: ce(u()),
  // For Firestore ID data
  name: u(),
  requests: S(
    de(
      () => U([
        bt($r),
        bt(Zs)
      ])
    )
  )
}), Ry = Ey.extend({
  folders: de(() => S(ve(Q, 1)))
}), Ku = A({
  initial: !0,
  schema: Ry
}), El = f({
  v: d(2),
  id: ce(u()),
  // For Firestore ID data
  name: u(),
  requests: S(
    de(
      () => U([
        bt($r),
        bt(Zs)
      ])
    )
  ),
  auth: U([Nc, pl]),
  headers: U([Oc, S(Gs)])
}), wy = El.extend({
  folders: de(() => S(ve(Q, 2)))
}), Cy = A({
  initial: !1,
  schema: wy,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: [],
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 2);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
    return e.id && (t.id = e.id), t;
  }
}), Rl = El.extend({
  v: d(3),
  // AWS Signature Authorization type addition
  auth: U([Uc, vl]),
  // `description` field addition under `headers`
  headers: U([Pr, S(ml)])
}), Iy = Rl.extend({
  folders: de(() => S(ve(Q, 3)))
}), xy = A({
  initial: !1,
  schema: Iy,
  up(e) {
    const t = e.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...e,
      v: 3,
      headers: t,
      folders: e.folders.map((n) => {
        const a = Q.safeParseUpToVersion(n, 3);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), wl = Rl.extend({
  v: d(4),
  auth: U([js, _l])
}), Oy = wl.extend({
  folders: de(() => S(ve(Q, 4)))
}), ky = A({
  initial: !1,
  schema: Oy,
  up(e) {
    return {
      ...e,
      v: 4,
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 4);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), ee = [];
for (let e = 0; e < 256; ++e)
  ee.push((e + 256).toString(16).slice(1));
function Py(e, t = 0) {
  return (ee[e[t + 0]] + ee[e[t + 1]] + ee[e[t + 2]] + ee[e[t + 3]] + "-" + ee[e[t + 4]] + ee[e[t + 5]] + "-" + ee[e[t + 6]] + ee[e[t + 7]] + "-" + ee[e[t + 8]] + ee[e[t + 9]] + "-" + ee[e[t + 10]] + ee[e[t + 11]] + ee[e[t + 12]] + ee[e[t + 13]] + ee[e[t + 14]] + ee[e[t + 15]]).toLowerCase();
}
let as;
const qy = new Uint8Array(16);
function Vy() {
  if (!as) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    as = crypto.getRandomValues.bind(crypto);
  }
  return as(qy);
}
const $y = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Bu = { randomUUID: $y };
function My(e, t, r) {
  var a;
  if (Bu.randomUUID && !e)
    return Bu.randomUUID();
  e = e || {};
  const n = e.random ?? ((a = e.rng) == null ? void 0 : a.call(e)) ?? Vy();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Py(n);
}
const Cl = (e = "") => {
  const t = Date.now().toString(36), r = My();
  return `${e}_${t}_${r}`;
}, Il = wl.extend({
  v: d(5),
  _ref_id: u().optional()
}), Ny = Il.extend({
  folders: de(() => S(ve(Q, 5)))
}), jy = A({
  initial: !1,
  schema: Ny,
  up(e) {
    return {
      ...e,
      v: 5,
      _ref_id: Cl("coll"),
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 5);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), xl = Il.extend({
  v: d(6),
  auth: U([Ds, Nr])
}), Dy = xl.extend({
  folders: de(() => S(ve(Q, 6)))
}), Hy = A({
  initial: !1,
  schema: Dy,
  up(e) {
    const t = e.auth, r = t.authType === "oauth-2" ? {
      ...t,
      grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
        ...t.grantTypeInfo,
        clientAuthentication: "IN_BODY"
      } : t.grantTypeInfo
    } : t;
    return {
      ...e,
      auth: r,
      v: 6,
      folders: e.folders.map((a) => {
        const s = Q.safeParseUpToVersion(a, 6);
        if (s.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return s.value;
      })
    };
  }
}), Ol = xl.extend({
  v: d(7),
  auth: U([Ks, Nr])
}), Ly = Ol.extend({
  folders: de(() => S(ve(Q, 7)))
}), Uy = A({
  initial: !1,
  schema: Ly,
  up(e) {
    return {
      ...e,
      v: 7,
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 7);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), kl = Ol.extend({
  v: d(8),
  auth: U([Bs, Nr])
}), Ky = kl.extend({
  folders: de(() => S(ve(Q, 8)))
}), By = A({
  initial: !1,
  schema: Ky,
  up(e) {
    return {
      ...e,
      v: 8,
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 8);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Pl = kl.extend({
  v: d(9),
  auth: U([Vr, Al])
}), Gy = Pl.extend({
  folders: de(() => S(ve(Q, 9)))
}), Fy = A({
  initial: !1,
  schema: Gy,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const n = e.auth.grantTypeInfo;
      let a;
      n.grantType === "AUTHORIZATION_CODE" ? a = {
        ...n,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "CLIENT_CREDENTIALS" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "PASSWORD" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "IMPLICIT" ? a = {
        ...n,
        authRequestParams: [],
        refreshRequestParams: []
      } : a = n, t = {
        ...e.auth,
        grantTypeInfo: a
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t,
      folders: e.folders.map((n) => {
        const a = Q.safeParseUpToVersion(n, 9);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), Zy = f({
  key: u(),
  initialValue: u(),
  currentValue: u(),
  secret: C()
}), Wy = Pl.extend({
  v: d(10),
  variables: S(Zy)
}), Jy = Wy.extend({
  folders: de(() => S(ve(Q, 10)))
}), zy = A({
  initial: !1,
  schema: Jy,
  up(e) {
    return {
      ...e,
      v: 10,
      variables: [],
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 10);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Qy = f({
  v: wt()
}), Q = tt({
  latestVersion: 10,
  versionMap: {
    1: Ku,
    2: Cy,
    3: xy,
    4: ky,
    5: jy,
    6: Hy,
    7: Uy,
    8: By,
    9: Fy,
    10: zy
  },
  getVersion(e) {
    const t = Qy.safeParse(e);
    return t.success ? t.data.v : Ku.schema.safeParse(e).success ? 1 : null;
  }
}), Yy = 10;
function ql(e) {
  return {
    v: Yy,
    ...e,
    _ref_id: e._ref_id ? e._ref_id : Cl("coll")
  };
}
function Xy(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(Xy), n = (e.requests ?? []).map(ay), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = e.variables ?? [], o = ql({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s,
    variables: i
  });
  return e.id && (o.id = e.id), e._ref_id && (o._ref_id = e._ref_id), o;
}
function em(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(em), n = (e.requests ?? []).map(Ty), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = e.variables ?? [], o = ql({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s,
    variables: i
  });
  return e.id && (o.id = e.id), e._ref_id && (o._ref_id = e._ref_id), o;
}
var Be = function(e) {
  return function(t) {
    return !e(t);
  };
}, tm = rf, rm = ef;
function Vl(e, t) {
  return t === void 0 ? function(r) {
    return Vl(e, r);
  } : rm(e, t) ? ec : tc(t[e]);
}
var $l = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, nm = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var a = e(n, t[n]);
      Xu(a) && r.push(a.value);
    }
    return r;
  };
}, am = function(e) {
  return nm(function(t, r) {
    return e(r);
  });
}, Ml = function(e) {
  return e.slice();
}, sm = Xd, Gu = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, im = function(e) {
  return function(t) {
    return Gu(Gu([], t, !0), [e], !1);
  };
}, om = im, um = function(e) {
  return [e];
}, cm = om, lm = Vl, dm = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, fm = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, hm = function() {
  return {
    concat: fm().concat,
    empty: []
  };
}, jr = ec, Kt = tc;
function Nl(e) {
  return function(t) {
    return e(t) ? Kt(t) : jr;
  };
}
var ps = function(e) {
  return function(t) {
    return jl(t) ? jr : Kt(e(t.value));
  };
}, pm = Xu, jl = function(e) {
  return e._tag === "None";
}, ym = function(e, t) {
  return function(r) {
    return jl(r) ? e() : t(r.value);
  };
}, mm = ym, Ws = mm, vm = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, Ge = Bd, ye = Gd, gm = /* @__PURE__ */ Dd(2, function(e, t) {
  return St(e) ? e : t(e.right);
}), Bt = function(e) {
  return function(t) {
    return St(t) ? t : ye(e(t.right));
  };
}, Dr = function(e) {
  return function(t) {
    return St(t) ? Ge(e(t.left)) : t;
  };
}, St = Ud, _m = Kd, bm = function(e) {
  return function(t) {
    return St(t) ? e(t.left) : t.right;
  };
}, Js = bm, Fu = gm, hr = function() {
  return hr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, hr.apply(this, arguments);
}, Gt = function(e, t, r) {
  return ye({
    value: e,
    next: t,
    start: r
  });
}, Ft = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), Ge({
    input: e,
    expected: t,
    fatal: r
  });
}, Sm = function(e, t) {
  return hr(hr({}, e), { expected: t });
}, Am = function(e, t) {
  return Tm().concat(e, t);
}, Tm = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? Qd().concat(e, t) : e.input.cursor > t.input.cursor ? Br().concat(e, t) : zd({
        input: Br(),
        fatal: Br(),
        expected: hm()
      }).concat(e, t);
    }
  };
}, Em = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, Rm = function(e) {
  return lm(e.cursor, e.buffer);
}, wm = function(e) {
  return e.cursor >= e.buffer.length;
}, Cm = function(e) {
  return b(Rm(e), ps(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, je = function() {
  return je = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, je.apply(this, arguments);
}, zs = function(e) {
  return function(t) {
    return Gt(e, t, t);
  };
}, Im = function() {
  return function(e) {
    return Ft(e);
  };
}, xm = function(e) {
  return function() {
    return Ft(e);
  };
}, X = function(e) {
  return b(Pm(Om()), nt(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? At(r) : xm(n);
  }));
}, Y = function(e, t) {
  return function(r) {
    return b(e(r), Dr(function(n) {
      return Sm(n, [t]);
    }));
  };
}, Om = function() {
  return function(e) {
    return b(Cm(e), Ws(function() {
      return Ft(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return Gt(r, n, e);
    }));
  };
}, km = function(e, t) {
  return function(r) {
    return b(e(r), Fu(function(n) {
      return b(t(n.value)(n.next), Fu(function(a) {
        return Gt(a.value, a.next, r);
      }));
    }));
  };
}, Hr = function(e, t) {
  return function(r) {
    var n = e(r);
    return _m(n) || n.left.fatal ? n : b(t()(r), Dr(function(a) {
      return Am(n.left, a);
    }));
  };
}, Pm = function(e) {
  return function(t) {
    return b(e(t), Bt(function(r) {
      return je(je({}, r), { value: [r.value, t] });
    }));
  };
}, Dl = function(e) {
  return at(function() {
    return At(e.empty);
  });
}, Qs = function() {
  return Y(function(e) {
    return wm(e) ? Gt(void 0, e, e) : Ft(e);
  }, "end of file");
}, qm = function(e) {
  return b(Ys(e), at(function() {
    return At([]);
  }));
}, Ys = function(e) {
  return b(e, nt(function(t) {
    return ei(um(t), function(r) {
      return b(e, z(function(n) {
        return Ge(cm(n)(r));
      }), at(function() {
        return At(ye(r));
      }));
    });
  }));
}, Vm = function(e, t) {
  return function(r) {
    return b(e, nt(function() {
      return r;
    }), ti(function() {
      return t;
    }));
  };
}, Hl = function(e) {
  return Vm(e, e);
}, $m = function(e) {
  return qm(X(Be(e)));
}, Xs = function(e, t) {
  return b(t, z(function() {
    return sm;
  }), at(function() {
    return Mm(e, t);
  }));
}, Mm = function(e, t) {
  return b(e, nt(function(r) {
    return ei(nf(r), function(n) {
      return b(t, z(function() {
        return ye(n);
      }), at(function() {
        return b(e, z(function(a) {
          return Ge(tm(a)(n));
        }));
      }));
    });
  }));
}, Zt = function(e, t) {
  return function(r) {
    return b(e(r), Bt(function(n) {
      return je(je({}, n), { value: t(n.value) });
    }));
  };
}, Ll = function(e, t) {
  return Lr(e, function(r) {
    return Zt(t, r);
  });
}, Lr = function(e, t) {
  return km(e, t);
}, ei = function(e, t) {
  var r = function(n) {
    return function(a) {
      return St(a.value) ? Ge({ value: a.value.left, stream: a.next }) : ye(Gt(a.value.right, a.next, n));
    };
  };
  return function(n) {
    return vm({ value: e, stream: n }, function(a) {
      var s = t(a.value)(a.stream);
      return St(s) ? ye(Ft(a.stream, s.left.expected, s.left.fatal)) : r(n)(s.right);
    });
  };
}, Nm = function(e, t) {
  return Hr(e, t);
}, z = function(e) {
  return function(t) {
    return Zt(t, e);
  };
}, At = zs, nt = function(e) {
  return function(t) {
    return Lr(t, e);
  };
}, ti = function(e) {
  return function(t) {
    return Lr(t, function(r) {
      return Zt(e(r), function() {
        return r;
      });
    });
  };
}, at = function(e) {
  return function(t) {
    return Nm(t, e);
  };
}, jm = "Parser", Dm = function(e) {
  return {
    concat: function(t, r) {
      return Ll(Zt(t, function(n) {
        return function(a) {
          return e.concat(n, a);
        };
      }), r);
    }
  };
}, Hm = function(e) {
  return je(je({}, Dm(e)), { empty: zs(e.empty) });
}, Lm = {
  URI: jm,
  map: Zt,
  ap: Ll,
  chain: Lr,
  chainRec: ei
}, Ul = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, Kl = function(e) {
  return function(t) {
    return b(t, z(function(r) {
      return Ul({}, e, r);
    }));
  };
}, ys = function(e, t) {
  return function(r) {
    return b(r, nt(function(n) {
      return b(t(n), z(function(a) {
        return Ul(n, e, a);
      }));
    }));
  };
}, Um = function(e) {
  return Yd(e)(e.empty);
}, Km = Dl(_s), Tt = function(e) {
  return Y(X(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, Bm = function(e) {
  return Y(X(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, ri = function(e) {
  return Km(Wt(e));
}, Wt = function(e) {
  return b(Ys(e), z(function(t) {
    return t.join("");
  }));
}, ni = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, ms = Y(X(ni), "a digit"), Gm = /^\s$/, Bl = function(e) {
  return Gm.test(e);
}, Gl = Y(X(Bl), "a whitespace"), Fm = function(e) {
  return e === "_";
}, Jt = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, Fl = function(e) {
  return Jt(e) || ni(e) || Fm(e);
};
Y(X(Fl), "a word character");
Y(X(Jt), "a letter");
var Zm = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
Y(X(Zm), "an unicode letter");
var Zl = function(e) {
  return Jt(e) && e === e.toUpperCase();
};
Y(X(Zl), "an upper case letter");
var Wl = function(e) {
  return Jt(e) && e === e.toLowerCase();
};
Y(X(Wl), "a lower case letter");
Y(X(Be(ni)), "a non-digit");
var Jl = Y(X(Be(Bl)), "a non-whitespace character");
Y(X(Be(Fl)), "a non-word character");
Y(X(Be(Jt)), "a non-letter character");
Y(X(Be(Zl)), "anything but an upper case letter");
Y(X(Be(Wl)), "anything but a lower case letter");
var zl = function(e) {
  return Y(Lm.chainRec(e, function(t) {
    return b(zm(0, t), Ws(function() {
      return At(ye(e));
    }, function(r) {
      return b(Tt(r), nt(function() {
        return At(Ge(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, vs = Um(Hm(_s)), Dt = Dl(_s), Wm = function(e) {
  return Dt(Jm(e));
}, Jm = function(e) {
  return b(Ys(e), z(function(t) {
    return t.join("");
  }));
}, zm = function(e, t) {
  return e >= 0 && e < t.length ? Kt(t.charAt(e)) : jr;
}, Qm = ri(Gl);
Wt(Gl);
ri(Jl);
Wt(Jl);
var Ym = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? jr : Kt(t);
};
Y(b(vs([Dt(Tt("-")), Wt(ms)]), z(function(e) {
  return +e;
})), "an integer");
Y(b(vs([Dt(Tt("-")), ri(ms), Dt(vs([Tt("."), Wt(ms)]))]), nt(function(e) {
  return b(Ym(e), Ws(function() {
    return Im();
  }, zs));
})), "a float");
var Xm = Hl(Tt('"'))(Wm(Hr(zl('\\"'), function() {
  return Bm('"');
})));
function Ql(e) {
  return function(t) {
    return t(Em(e.split("")));
  };
}
const Zu = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), ev = ["#", ":"], Et = Hl(Qm), ai = (e) => (t) => t.join(e), si = (e) => b(
  $m((t) => e.includes(t)),
  z(ai(""))
), tv = $e(
  si,
  ti(() => X(() => !0))
), Yl = b(
  Xm,
  z((e) => JSON.parse(`"${e}"`))
), rv = b(
  Et(Yl),
  at(
    () => b(
      si([":", `
`]),
      z(rc)
    )
  )
), nv = b(
  Et(Yl),
  at(
    () => b(
      si([`
`]),
      z(rc)
    )
  )
), Xl = b(
  Dt(zl("#")),
  z(Be(nc))
), ed = b(
  Et(Xl),
  Kl("commented"),
  ys("key", () => Et(rv)),
  ti(() => Tt(":")),
  ys("value", () => nv)
), av = b(
  Et(Xl),
  Kl("commented"),
  ys("key", () => Hr(
    tv([`
`]),
    () => b(
      Xs(X((e) => !0), Qs()),
      z($e(
        Ml,
        ai("")
      ))
    )
  )),
  z($e(
    Nl(({ key: e }) => !nc(e))
  ))
), sv = b(
  Xs(Et(ed), Qs())
), iv = b(
  Xs(
    Hr(
      b(ed, z(Kt)),
      () => b(
        av,
        z($e(
          ps((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    Qs()
  ),
  z($e(
    am($e(
      Nl(pm),
      ps((e) => e.value)
    ))
  ))
), ov = (e) => {
  if (ev.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, Wu = (e) => ov(e) ? JSON.stringify(e) : e, pg = (e) => b(
  e,
  dm(
    $e(
      Zu("key", Wu),
      Zu("value", Wu),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  ai(`
`)
), uv = (e) => b(
  iv,
  Ql(e),
  Dr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Bt(
    ({ value: t }) => b(
      t,
      $l(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), yg = (e) => b(
  sv,
  Ql(e),
  Dr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Bt(
    ({ value: t }) => b(
      t,
      $l(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), mg = $e(
  uv,
  Bt(Ml),
  Js(() => [])
), cv = f({
  id: ce(u()),
  name: u(),
  variables: S(
    f({
      key: u(),
      value: u()
    })
  )
}), Ju = A({
  initial: !0,
  schema: cv
}), td = () => Math.random().toString(36).substring(2, 16), rd = f({
  v: d(1),
  id: u(),
  name: u(),
  variables: S(
    U([
      f({
        key: u(),
        secret: d(!0)
      }),
      f({
        key: u(),
        value: u(),
        secret: d(!1).catch(!1)
      })
    ])
  )
}), lv = A({
  initial: !1,
  schema: rd,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || td(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), dv = rd.extend({
  v: d(2),
  variables: S(
    f({
      key: u(),
      initialValue: u(),
      currentValue: u(),
      secret: C()
    })
  )
}), fv = A({
  initial: !1,
  schema: dv,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a,
          initialValue: a ? "" : r.value,
          currentValue: a ? "" : r.value
        };
      })
    };
  }
}), nd = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : r === 14 ? t += "4" : r === 19 ? t += e.charAt(8 + Math.floor(Math.random() * 4)) : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alphanumeric character.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return e.charAt(Math.floor(Math.random() * e.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const e = ["red", "green", "blue", "yellow", "purple", "orange"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "#";
      for (let r = 0; r < 6; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const e = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16)
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16)
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alphanumeric password.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let t = "";
      for (let r = 0; r < 15; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const e = ["ny", "sr", "si"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const e = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const e = ["http", "https"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${e[Math.floor(Math.random() * e.length)]} ${t[Math.floor(Math.random() * t.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const e = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const e = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const e = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const e = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const e = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const e = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const e = ["Supervisor", "Manager", "Coordinator", "Director"];
      return e[Math.floor(Math.random() * e.length)];
    }
  }
  // TODO: Support various other predefined variables
], hv = f({
  v: wt()
}), vg = tt({
  latestVersion: 2,
  versionMap: {
    0: Ju,
    1: lv,
    2: fv
  },
  getVersion(e) {
    const t = hv.safeParse(e);
    return t.success ? t.data.v : Ju.schema.safeParse(e).success ? 0 : null;
  }
}), pr = /<<([^>]*)>>/g, yr = 10, ad = "ENV_EXPAND_LOOP", zu = 2;
function pv(e, t) {
  let r = e, n = 0;
  for (; r.match(pr) != null && n <= yr; )
    r = r.replace(pr, (a) => {
      const s = a.replace(/[<>]/g, ""), i = nd.find(
        (c) => c.key === s
      );
      if (i)
        return i.getValue();
      const o = t.find((c) => c.key === s);
      return o && "currentValue" in o ? o.currentValue : a;
    }), n++;
  return n > yr ? Ge(ad) : ye(r);
}
const gg = (e, t) => b(
  pv(e, t),
  Js(() => e)
);
function yv(e, t, r = !1, n = !1) {
  if (!t || !e)
    return ye(e);
  let a = e, s = 0, i = !1;
  for (; a.match(pr) != null && s <= yr && !i; )
    a = decodeURI(encodeURI(a)).replace(pr, (o, c) => {
      const l = nd.find(
        (m) => m.key === c
      );
      if (l)
        return l.getValue();
      const h = t.find((m) => m && m.key === c);
      return h && "currentValue" in h ? h.secret && n ? (i = !0, `<<${c}>>`) : h.secret && r ? "*".repeat(
        h.currentValue.length
      ) : h.currentValue : "";
    }), s++;
  return s > yr ? Ge(ad) : ye(a);
}
const _g = (e, t, r = !1, n = !1) => b(
  yv(e, t, r, n),
  Js(() => e)
), mv = (e) => ({
  key: e.key,
  initialValue: e.initialValue ?? e.value ?? "",
  currentValue: e.currentValue ?? e.value ?? "",
  secret: e.secret ?? !1
}), bg = (e) => {
  if (e.v && e.v === zu) return e;
  const t = e.id || td(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(mv);
  return {
    v: zu,
    id: t,
    name: r,
    variables: n
  };
}, vv = S(
  U([
    f({
      key: u(),
      value: u(),
      secret: d(!1)
    }),
    f({
      key: u(),
      secret: d(!0)
    }),
    f({
      key: u(),
      value: u()
    })
  ])
), Qu = A({
  initial: !0,
  schema: vv
}), sd = f({
  v: d(1),
  variables: S(
    U([
      f({
        key: u(),
        secret: d(!0)
      }),
      f({
        key: u(),
        value: u(),
        secret: d(!1)
      })
    ])
  )
}), gv = A({
  initial: !1,
  schema: sd,
  up(e) {
    return {
      v: 1,
      variables: e.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), _v = sd.extend({
  v: d(2),
  variables: S(
    f({
      key: u(),
      initialValue: u(),
      currentValue: u(),
      secret: C()
    })
  )
}), bv = A({
  initial: !1,
  schema: _v,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a ?? !1,
          initialValue: r.secret ? "" : r.value,
          currentValue: r.secret ? "" : r.value
        };
      })
    };
  }
}), Sv = f({
  v: wt()
}), Sg = tt({
  latestVersion: 2,
  versionMap: {
    0: Qu,
    1: gv,
    2: bv
  },
  getVersion(e) {
    const t = Sv.safeParse(e);
    return t.success ? t.data.v : Qu.schema.safeParse(e).success ? 0 : null;
  }
});
async function Av(e = 6) {
  const t = new Uint8Array(e);
  return crypto.getRandomValues(t), Array.from(t).map((r) => r.toString(16).padStart(2, "0")).join("").substring(0, e);
}
function Tv(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-256", r);
}
function Ev(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-1", r);
}
async function Rv(e, t) {
  return t === "sha256" ? Tv(e) : Ev(e);
}
async function wv(e, t, r) {
  const n = new TextEncoder(), a = n.encode(e), s = n.encode(t), i = r === "sha256" ? "SHA-256" : "SHA-1", o = await crypto.subtle.importKey(
    "raw",
    a,
    {
      name: "HMAC",
      hash: { name: i }
    },
    !1,
    ["sign"]
  ), c = await crypto.subtle.sign("HMAC", o, s);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(c)]));
}
function dt(e) {
  return e.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
}
async function Cv(e, t) {
  if (!e) return "";
  if (e instanceof FormData)
    if (t === "multipart/form-data") {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" ? r.push(`${a}=${n}`) : r.push(`${a}=${n instanceof File ? n.name : "blob"}`);
      }), dt(r.join("&"));
    } else {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" && r.push(`${a}=${encodeURIComponent(n)}`);
      }), dt(r.join("&"));
    }
  if (e instanceof Blob)
    try {
      const r = await e.text();
      return dt(r);
    } catch (r) {
      return console.error("Failed to read blob content", r), "";
    }
  if (t.includes("application/json") && typeof e == "string")
    try {
      const r = JSON.parse(e);
      return dt(JSON.stringify(r));
    } catch {
      return dt(e.toString());
    }
  return dt(e.toString());
}
async function Ag(e) {
  const t = e.timestamp !== void 0 && e.timestamp !== null ? e.timestamp : Math.floor(Date.now() / 1e3), r = e.nonce && e.nonce !== "" ? e.nonce : await Av(), n = new URL(e.url), a = n.hostname, s = n.port || (n.protocol === "https:" ? "443" : "80"), i = n.pathname + n.search, o = {
    ts: t,
    nonce: r,
    method: e.method.toUpperCase(),
    resource: i,
    host: a,
    port: s,
    hash: "",
    ext: e.ext || ""
  };
  if (e.includePayloadHash && e.payload)
    try {
      const m = e.contentType || "text/plain", E = await Cv(e.payload, m), j = `hawk.1.payload
${m}
${E}
`, Z = await Rv(j, e.algorithm);
      o.hash = btoa(
        String.fromCharCode.apply(null, [...new Uint8Array(Z)])
      );
    } catch (m) {
      console.error("Error calculating payload hash:", m);
    }
  const c = `hawk.1.header
${o.ts}
${o.nonce}
${o.method}
${o.resource}
${o.host}
${o.port}
${o.hash}
${o.ext}
`, l = await wv(e.key, c, e.algorithm), h = [
    `Hawk id="${e.id}"`,
    `ts="${o.ts}"`,
    `nonce="${o.nonce}"`,
    `mac="${l}"`
  ];
  return e.ext && e.ext !== "" && h.push(`ext="${e.ext}"`), e.app && e.app !== "" && h.push(`app="${e.app}"`), e.dlg && e.dlg !== "" && h.push(`dlg="${e.dlg}"`), o.hash !== "" && h.push(`hash="${o.hash}"`), h.join(", ");
}
async function Tg(e) {
  const t = new TextEncoder();
  new TextDecoder();
  const r = e.timestamp || Math.floor(Date.now() / 1e3).toString(), n = e.nonce || crypto.randomUUID(), a = e.host || new URL(e.url).host, s = await crypto.subtle.importKey(
    "raw",
    t.encode(e.clientSecret),
    { name: "HMAC", hash: "SHA-256" },
    !1,
    ["sign"]
  );
  await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(r)
  );
  let i = "";
  if (e.body) {
    const m = await crypto.subtle.digest(
      "SHA-256",
      t.encode(e.body)
    );
    i = Array.from(new Uint8Array(m)).map((E) => E.toString(16).padStart(2, "0")).join("");
  }
  const o = `${e.method} ${e.url} ${a} ${r} ${n} ${i}`, c = await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(o)
  ), l = btoa(
    String.fromCharCode(...new Uint8Array(c))
  );
  return `EG1-HMAC-SHA256 client_token=${e.clientToken};access_token=${e.accessToken};timestamp=${r};nonce=${n};signature=${l}`;
}
const yt = new TextEncoder(), mr = new TextDecoder();
function Iv(...e) {
  const t = e.reduce((a, { length: s }) => a + s, 0), r = new Uint8Array(t);
  let n = 0;
  for (const a of e)
    r.set(a, n), n += a.length;
  return r;
}
function xv(e) {
  if (Uint8Array.prototype.toBase64)
    return e.toBase64();
  const t = 32768, r = [];
  for (let n = 0; n < e.length; n += t)
    r.push(String.fromCharCode.apply(null, e.subarray(n, n + t)));
  return btoa(r.join(""));
}
function Ov(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(e);
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function kv(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(typeof e == "string" ? e : mr.decode(e), {
      alphabet: "base64url"
    });
  let t = e;
  t instanceof Uint8Array && (t = mr.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return Ov(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
function ss(e) {
  let t = e;
  return typeof t == "string" && (t = yt.encode(t)), Uint8Array.prototype.toBase64 ? t.toBase64({ alphabet: "base64url", omitPadding: !0 }) : xv(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
class Ur extends Error {
  constructor(r, n) {
    var a;
    super(r, n);
    Ae(this, "code", "ERR_JOSE_GENERIC");
    this.name = this.constructor.name, (a = Error.captureStackTrace) == null || a.call(Error, this, this.constructor);
  }
}
Ae(Ur, "code", "ERR_JOSE_GENERIC");
class Je extends Ur {
  constructor() {
    super(...arguments);
    Ae(this, "code", "ERR_JOSE_NOT_SUPPORTED");
  }
}
Ae(Je, "code", "ERR_JOSE_NOT_SUPPORTED");
class ht extends Ur {
  constructor() {
    super(...arguments);
    Ae(this, "code", "ERR_JWS_INVALID");
  }
}
Ae(ht, "code", "ERR_JWS_INVALID");
class id extends Ur {
  constructor() {
    super(...arguments);
    Ae(this, "code", "ERR_JWT_INVALID");
  }
}
Ae(id, "code", "ERR_JWT_INVALID");
function Te(e, t = "algorithm.name") {
  return new TypeError(`CryptoKey does not support this operation, its ${t} must be ${e}`);
}
function xt(e, t) {
  return e.name === t;
}
function is(e) {
  return parseInt(e.name.slice(4), 10);
}
function Pv(e) {
  switch (e) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function qv(e, t) {
  if (!e.usages.includes(t))
    throw new TypeError(`CryptoKey does not support this operation, its usages must include ${t}.`);
}
function Vv(e, t, r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!xt(e.algorithm, "HMAC"))
        throw Te("HMAC");
      const n = parseInt(t.slice(2), 10);
      if (is(e.algorithm.hash) !== n)
        throw Te(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!xt(e.algorithm, "RSASSA-PKCS1-v1_5"))
        throw Te("RSASSA-PKCS1-v1_5");
      const n = parseInt(t.slice(2), 10);
      if (is(e.algorithm.hash) !== n)
        throw Te(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!xt(e.algorithm, "RSA-PSS"))
        throw Te("RSA-PSS");
      const n = parseInt(t.slice(2), 10);
      if (is(e.algorithm.hash) !== n)
        throw Te(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "Ed25519":
    case "EdDSA": {
      if (!xt(e.algorithm, "Ed25519"))
        throw Te("Ed25519");
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!xt(e.algorithm, "ECDSA"))
        throw Te("ECDSA");
      const n = Pv(t);
      if (e.algorithm.namedCurve !== n)
        throw Te(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  qv(e, r);
}
function od(e, t, ...r) {
  var n;
  if (r = r.filter(Boolean), r.length > 2) {
    const a = r.pop();
    e += `one of type ${r.join(", ")}, or ${a}.`;
  } else r.length === 2 ? e += `one of type ${r[0]} or ${r[1]}.` : e += `of type ${r[0]}.`;
  return t == null ? e += ` Received ${t}` : typeof t == "function" && t.name ? e += ` Received function ${t.name}` : typeof t == "object" && t != null && (n = t.constructor) != null && n.name && (e += ` Received an instance of ${t.constructor.name}`), e;
}
const $v = (e, ...t) => od("Key must be ", e, ...t);
function ud(e, t, ...r) {
  return od(`Key for the ${e} algorithm must be `, t, ...r);
}
function cd(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "CryptoKey";
}
function ld(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "KeyObject";
}
const dd = (e) => cd(e) || ld(e), Mv = (...e) => {
  const t = e.filter(Boolean);
  if (t.length === 0 || t.length === 1)
    return !0;
  let r;
  for (const n of t) {
    const a = Object.keys(n);
    if (!r || r.size === 0) {
      r = new Set(a);
      continue;
    }
    for (const s of a) {
      if (r.has(s))
        return !1;
      r.add(s);
    }
  }
  return !0;
};
function Nv(e) {
  return typeof e == "object" && e !== null;
}
const fd = (e) => {
  if (!Nv(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}, jv = (e, t) => {
  if (e.startsWith("RS") || e.startsWith("PS")) {
    const { modulusLength: r } = t.algorithm;
    if (typeof r != "number" || r < 2048)
      throw new TypeError(`${e} requires key modulusLength to be 2048 bits or larger`);
  }
};
function Dv(e) {
  let t, r;
  switch (e.kty) {
    case "RSA": {
      switch (e.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          t = { name: "RSA-PSS", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          t = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          t = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(e.alg.slice(-3), 10) || 1}`
          }, r = e.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new Je('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (e.alg) {
        case "ES256":
          t = { name: "ECDSA", namedCurve: "P-256" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          t = { name: "ECDSA", namedCurve: "P-384" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          t = { name: "ECDSA", namedCurve: "P-521" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: "ECDH", namedCurve: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Je('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (e.alg) {
        case "Ed25519":
        case "EdDSA":
          t = { name: "Ed25519" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Je('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new Je('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: t, keyUsages: r };
}
const Hv = async (e) => {
  if (!e.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: t, keyUsages: r } = Dv(e), n = { ...e };
  return delete n.alg, delete n.use, crypto.subtle.importKey("jwk", n, t, e.ext ?? !e.d, e.key_ops ?? r);
}, Lv = (e, t, r, n, a) => {
  if (a.crit !== void 0 && (n == null ? void 0 : n.crit) === void 0)
    throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!n || n.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(n.crit) || n.crit.length === 0 || n.crit.some((i) => typeof i != "string" || i.length === 0))
    throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let s;
  r !== void 0 ? s = new Map([...Object.entries(r), ...t.entries()]) : s = t;
  for (const i of n.crit) {
    if (!s.has(i))
      throw new Je(`Extension Header Parameter "${i}" is not recognized`);
    if (a[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" is missing`);
    if (s.get(i) && n[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" MUST be integrity protected`);
  }
  return new Set(n.crit);
};
function ii(e) {
  return fd(e) && typeof e.kty == "string";
}
function Uv(e) {
  return e.kty !== "oct" && typeof e.d == "string";
}
function Kv(e) {
  return e.kty !== "oct" && typeof e.d > "u";
}
function Bv(e) {
  return e.kty === "oct" && typeof e.k == "string";
}
let mt;
const Yu = async (e, t, r, n = !1) => {
  mt || (mt = /* @__PURE__ */ new WeakMap());
  let a = mt.get(e);
  if (a != null && a[r])
    return a[r];
  const s = await Hv({ ...t, alg: r });
  return n && Object.freeze(e), a ? a[r] = s : mt.set(e, { [r]: s }), s;
}, Gv = (e, t) => {
  var i;
  mt || (mt = /* @__PURE__ */ new WeakMap());
  let r = mt.get(e);
  if (r != null && r[t])
    return r[t];
  const n = e.type === "public", a = !!n;
  let s;
  if (e.asymmetricKeyType === "x25519") {
    switch (t) {
      case "ECDH-ES":
      case "ECDH-ES+A128KW":
      case "ECDH-ES+A192KW":
      case "ECDH-ES+A256KW":
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    s = e.toCryptoKey(e.asymmetricKeyType, a, n ? [] : ["deriveBits"]);
  }
  if (e.asymmetricKeyType === "ed25519") {
    if (t !== "EdDSA" && t !== "Ed25519")
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    s = e.toCryptoKey(e.asymmetricKeyType, a, [
      n ? "verify" : "sign"
    ]);
  }
  if (e.asymmetricKeyType === "rsa") {
    let o;
    switch (t) {
      case "RSA-OAEP":
        o = "SHA-1";
        break;
      case "RS256":
      case "PS256":
      case "RSA-OAEP-256":
        o = "SHA-256";
        break;
      case "RS384":
      case "PS384":
      case "RSA-OAEP-384":
        o = "SHA-384";
        break;
      case "RS512":
      case "PS512":
      case "RSA-OAEP-512":
        o = "SHA-512";
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    if (t.startsWith("RSA-OAEP"))
      return e.toCryptoKey({
        name: "RSA-OAEP",
        hash: o
      }, a, n ? ["encrypt"] : ["decrypt"]);
    s = e.toCryptoKey({
      name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
      hash: o
    }, a, [n ? "verify" : "sign"]);
  }
  if (e.asymmetricKeyType === "ec") {
    const c = (/* @__PURE__ */ new Map([
      ["prime256v1", "P-256"],
      ["secp384r1", "P-384"],
      ["secp521r1", "P-521"]
    ])).get((i = e.asymmetricKeyDetails) == null ? void 0 : i.namedCurve);
    if (!c)
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    t === "ES256" && c === "P-256" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: c
    }, a, [n ? "verify" : "sign"])), t === "ES384" && c === "P-384" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: c
    }, a, [n ? "verify" : "sign"])), t === "ES512" && c === "P-521" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: c
    }, a, [n ? "verify" : "sign"])), t.startsWith("ECDH-ES") && (s = e.toCryptoKey({
      name: "ECDH",
      namedCurve: c
    }, a, n ? [] : ["deriveBits"]));
  }
  if (!s)
    throw new TypeError("given KeyObject instance cannot be used for this algorithm");
  return r ? r[t] = s : mt.set(e, { [t]: s }), s;
}, Fv = async (e, t) => {
  if (e instanceof Uint8Array || cd(e))
    return e;
  if (ld(e)) {
    if (e.type === "secret")
      return e.export();
    if ("toCryptoKey" in e && typeof e.toCryptoKey == "function")
      try {
        return Gv(e, t);
      } catch (n) {
        if (n instanceof TypeError)
          throw n;
      }
    let r = e.export({ format: "jwk" });
    return Yu(e, r, t);
  }
  if (ii(e))
    return e.k ? kv(e.k) : Yu(e, e, t, !0);
  throw new Error("unreachable");
}, pt = (e) => e == null ? void 0 : e[Symbol.toStringTag], gs = (e, t, r) => {
  var n, a;
  if (t.use !== void 0) {
    let s;
    switch (r) {
      case "sign":
      case "verify":
        s = "sig";
        break;
      case "encrypt":
      case "decrypt":
        s = "enc";
        break;
    }
    if (t.use !== s)
      throw new TypeError(`Invalid key for this operation, its "use" must be "${s}" when present`);
  }
  if (t.alg !== void 0 && t.alg !== e)
    throw new TypeError(`Invalid key for this operation, its "alg" must be "${e}" when present`);
  if (Array.isArray(t.key_ops)) {
    let s;
    switch (!0) {
      case r === "sign":
      case e === "dir":
      case e.includes("CBC-HS"):
        s = r;
        break;
      case e.startsWith("PBES2"):
        s = "deriveBits";
        break;
      case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
        !e.includes("GCM") && e.endsWith("KW") ? s = "unwrapKey" : s = r;
        break;
      case r === "encrypt":
        s = "wrapKey";
        break;
      case r === "decrypt":
        s = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        break;
    }
    if (s && ((a = (n = t.key_ops) == null ? void 0 : n.includes) == null ? void 0 : a.call(n, s)) === !1)
      throw new TypeError(`Invalid key for this operation, its "key_ops" must include "${s}" when present`);
  }
  return !0;
}, Zv = (e, t, r) => {
  if (!(t instanceof Uint8Array)) {
    if (ii(t)) {
      if (Bv(t) && gs(e, t, r))
        return;
      throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
    }
    if (!dd(t))
      throw new TypeError(ud(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
    if (t.type !== "secret")
      throw new TypeError(`${pt(t)} instances for symmetric algorithms must be of type "secret"`);
  }
}, Wv = (e, t, r) => {
  if (ii(t))
    switch (r) {
      case "decrypt":
      case "sign":
        if (Uv(t) && gs(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a private JWK");
      case "encrypt":
      case "verify":
        if (Kv(t) && gs(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a public JWK");
    }
  if (!dd(t))
    throw new TypeError(ud(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
  if (t.type === "secret")
    throw new TypeError(`${pt(t)} instances for asymmetric algorithms must not be of type "secret"`);
  if (t.type === "public")
    switch (r) {
      case "sign":
        throw new TypeError(`${pt(t)} instances for asymmetric algorithm signing must be of type "private"`);
      case "decrypt":
        throw new TypeError(`${pt(t)} instances for asymmetric algorithm decryption must be of type "private"`);
    }
  if (t.type === "private")
    switch (r) {
      case "verify":
        throw new TypeError(`${pt(t)} instances for asymmetric algorithm verifying must be of type "public"`);
      case "encrypt":
        throw new TypeError(`${pt(t)} instances for asymmetric algorithm encryption must be of type "public"`);
    }
}, Jv = (e, t, r) => {
  e.startsWith("HS") || e === "dir" || e.startsWith("PBES2") || /^A(?:128|192|256)(?:GCM)?(?:KW)?$/.test(e) || /^A(?:128|192|256)CBC-HS(?:256|384|512)$/.test(e) ? Zv(e, t, r) : Wv(e, t, r);
}, zv = (e, t) => {
  const r = `SHA-${e.slice(-3)}`;
  switch (e) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: r, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: r, name: "RSA-PSS", saltLength: parseInt(e.slice(-3), 10) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: r, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: r, name: "ECDSA", namedCurve: t.namedCurve };
    case "Ed25519":
    case "EdDSA":
      return { name: "Ed25519" };
    default:
      throw new Je(`alg ${e} is not supported either by JOSE or your javascript runtime`);
  }
}, Qv = async (e, t, r) => {
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS"))
      throw new TypeError($v(t, "CryptoKey", "KeyObject", "JSON Web Key"));
    return crypto.subtle.importKey("raw", t, { hash: `SHA-${e.slice(-3)}`, name: "HMAC" }, !1, [r]);
  }
  return Vv(t, e, r), t;
}, Ze = (e) => Math.floor(e.getTime() / 1e3), hd = 60, pd = hd * 60, oi = pd * 24, Yv = oi * 7, Xv = oi * 365.25, eg = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i, os = (e) => {
  const t = eg.exec(e);
  if (!t || t[4] && t[1])
    throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]), n = t[3].toLowerCase();
  let a;
  switch (n) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      a = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      a = Math.round(r * hd);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      a = Math.round(r * pd);
      break;
    case "day":
    case "days":
    case "d":
      a = Math.round(r * oi);
      break;
    case "week":
    case "weeks":
    case "w":
      a = Math.round(r * Yv);
      break;
    default:
      a = Math.round(r * Xv);
      break;
  }
  return t[1] === "-" || t[4] === "ago" ? -a : a;
};
function We(e, t) {
  if (!Number.isFinite(t))
    throw new TypeError(`Invalid ${e} input`);
  return t;
}
var F;
class tg {
  constructor(t) {
    Oe(this, F);
    if (!fd(t))
      throw new TypeError("JWT Claims Set MUST be an object");
    ke(this, F, structuredClone(t));
  }
  data() {
    return yt.encode(JSON.stringify(_(this, F)));
  }
  get iss() {
    return _(this, F).iss;
  }
  set iss(t) {
    _(this, F).iss = t;
  }
  get sub() {
    return _(this, F).sub;
  }
  set sub(t) {
    _(this, F).sub = t;
  }
  get aud() {
    return _(this, F).aud;
  }
  set aud(t) {
    _(this, F).aud = t;
  }
  set jti(t) {
    _(this, F).jti = t;
  }
  set nbf(t) {
    typeof t == "number" ? _(this, F).nbf = We("setNotBefore", t) : t instanceof Date ? _(this, F).nbf = We("setNotBefore", Ze(t)) : _(this, F).nbf = Ze(/* @__PURE__ */ new Date()) + os(t);
  }
  set exp(t) {
    typeof t == "number" ? _(this, F).exp = We("setExpirationTime", t) : t instanceof Date ? _(this, F).exp = We("setExpirationTime", Ze(t)) : _(this, F).exp = Ze(/* @__PURE__ */ new Date()) + os(t);
  }
  set iat(t) {
    typeof t > "u" ? _(this, F).iat = Ze(/* @__PURE__ */ new Date()) : t instanceof Date ? _(this, F).iat = We("setIssuedAt", Ze(t)) : typeof t == "string" ? _(this, F).iat = We("setIssuedAt", Ze(/* @__PURE__ */ new Date()) + os(t)) : _(this, F).iat = We("setIssuedAt", t);
  }
}
F = new WeakMap();
const rg = async (e, t, r) => {
  const n = await Qv(e, t, "sign");
  jv(e, n);
  const a = await crypto.subtle.sign(zv(e, n.algorithm), n, r);
  return new Uint8Array(a);
};
var Ht, oe, fe;
class ng {
  constructor(t) {
    Oe(this, Ht);
    Oe(this, oe);
    Oe(this, fe);
    if (!(t instanceof Uint8Array))
      throw new TypeError("payload must be an instance of Uint8Array");
    ke(this, Ht, t);
  }
  setProtectedHeader(t) {
    if (_(this, oe))
      throw new TypeError("setProtectedHeader can only be called once");
    return ke(this, oe, t), this;
  }
  setUnprotectedHeader(t) {
    if (_(this, fe))
      throw new TypeError("setUnprotectedHeader can only be called once");
    return ke(this, fe, t), this;
  }
  async sign(t, r) {
    if (!_(this, oe) && !_(this, fe))
      throw new ht("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
    if (!Mv(_(this, oe), _(this, fe)))
      throw new ht("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const n = {
      ..._(this, oe),
      ..._(this, fe)
    }, a = Lv(ht, /* @__PURE__ */ new Map([["b64", !0]]), r == null ? void 0 : r.crit, _(this, oe), n);
    let s = !0;
    if (a.has("b64") && (s = _(this, oe).b64, typeof s != "boolean"))
      throw new ht('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: i } = n;
    if (typeof i != "string" || !i)
      throw new ht('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    Jv(i, t, "sign");
    let o = _(this, Ht);
    s && (o = yt.encode(ss(o)));
    let c;
    _(this, oe) ? c = yt.encode(ss(JSON.stringify(_(this, oe)))) : c = yt.encode("");
    const l = Iv(c, yt.encode("."), o), h = await Fv(t, i), m = await rg(i, h, l), E = {
      signature: ss(m),
      payload: ""
    };
    return s && (E.payload = mr.decode(o)), _(this, fe) && (E.header = _(this, fe)), _(this, oe) && (E.protected = mr.decode(c)), E;
  }
}
Ht = new WeakMap(), oe = new WeakMap(), fe = new WeakMap();
var vt;
class ag {
  constructor(t) {
    Oe(this, vt);
    ke(this, vt, new ng(t));
  }
  setProtectedHeader(t) {
    return _(this, vt).setProtectedHeader(t), this;
  }
  async sign(t, r) {
    const n = await _(this, vt).sign(t, r);
    if (n.payload === void 0)
      throw new TypeError("use the flattened module for creating JWS with b64: false");
    return `${n.protected}.${n.payload}.${n.signature}`;
  }
}
vt = new WeakMap();
var Ve, ue;
class sg {
  constructor(t = {}) {
    Oe(this, Ve);
    Oe(this, ue);
    ke(this, ue, new tg(t));
  }
  setIssuer(t) {
    return _(this, ue).iss = t, this;
  }
  setSubject(t) {
    return _(this, ue).sub = t, this;
  }
  setAudience(t) {
    return _(this, ue).aud = t, this;
  }
  setJti(t) {
    return _(this, ue).jti = t, this;
  }
  setNotBefore(t) {
    return _(this, ue).nbf = t, this;
  }
  setExpirationTime(t) {
    return _(this, ue).exp = t, this;
  }
  setIssuedAt(t) {
    return _(this, ue).iat = t, this;
  }
  setProtectedHeader(t) {
    return ke(this, Ve, t), this;
  }
  async sign(t, r) {
    var a;
    const n = new ag(_(this, ue).data());
    if (n.setProtectedHeader(_(this, Ve)), Array.isArray((a = _(this, Ve)) == null ? void 0 : a.crit) && _(this, Ve).crit.includes("b64") && _(this, Ve).b64 === !1)
      throw new id("JWTs MUST NOT use unencoded payload");
    return n.sign(t, r);
  }
}
Ve = new WeakMap(), ue = new WeakMap();
async function Eg(e) {
  const {
    algorithm: t,
    secret: r,
    privateKey: n,
    payload: a,
    jwtHeaders: s,
    isSecretBase64Encoded: i
  } = e;
  let o = {}, c = {};
  try {
    const l = (a == null ? void 0 : a.trim()) || "{}";
    l === "" ? o = {} : o = JSON.parse(l);
  } catch (l) {
    return console.error("Failed to parse JWT payload JSON:", l), console.error("Payload value:", a), null;
  }
  try {
    const l = (s == null ? void 0 : s.trim()) || "{}";
    l === "" ? c = {} : c = JSON.parse(l);
  } catch (l) {
    return console.error("Failed to parse JWT headers JSON:", l), console.error("Headers value:", s), null;
  }
  try {
    let l;
    if (t.startsWith("RS") || t.startsWith("ES") || t.startsWith("PS")) {
      if (!n)
        return console.error("Private key is required for RSA/ECDSA algorithms"), null;
      l = new TextEncoder().encode(n);
    } else {
      if (!r)
        return console.error("Secret is required for HMAC algorithms"), null;
      l = i ? Uint8Array.from(Buffer.from(r, "base64")) : new TextEncoder().encode(r);
    }
    return await new sg(o).setProtectedHeader({
      alg: t,
      ...c
    }).sign(l);
  } catch (l) {
    return console.error("Error generating JWT token:", l), null;
  }
}
export {
  Op as AuthCodeGrantTypeParams,
  kp as ClientCredentialsGrantTypeParams,
  Yy as CollectionSchemaVersion,
  Zy as CollectionVariable,
  vg as Environment,
  zu as EnvironmentSchemaVersion,
  Fc as FormDataKeyValue,
  ml as GQLHeader,
  Tl as GQL_REQ_SCHEMA_VERSION,
  Sg as GlobalEnvironment,
  nd as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  Q as HoppCollection,
  Al as HoppGQLAuth,
  It as HoppGQLAuthAPIKey,
  Mr as HoppGQLAuthAWSSignature,
  Le as HoppGQLAuthBasic,
  Ue as HoppGQLAuthBearer,
  Ke as HoppGQLAuthInherit,
  He as HoppGQLAuthNone,
  tl as HoppGQLAuthOAuth2,
  Zs as HoppGQLRequest,
  Vr as HoppRESTAuth,
  De as HoppRESTAuthAPIKey,
  rt as HoppRESTAuthAWSSignature,
  Us as HoppRESTAuthAkamaiEdgeGrid,
  _e as HoppRESTAuthBasic,
  be as HoppRESTAuthBearer,
  Ut as HoppRESTAuthDigest,
  Ls as HoppRESTAuthHAWK,
  Se as HoppRESTAuthInherit,
  Yc as HoppRESTAuthJWT,
  ge as HoppRESTAuthNone,
  tl as HoppRESTAuthOAuth2,
  Pr as HoppRESTHeaders,
  Ms as HoppRESTParams,
  Hs as HoppRESTReqBody,
  $r as HoppRESTRequest,
  Bp as HoppRESTRequestResponse,
  rl as HoppRESTRequestResponses,
  $s as HoppRESTRequestVariables,
  Np as HoppRESTResponseOriginalRequest,
  qp as ImplicitOauthFlowParams,
  Pp as PasswordGrantTypeParams,
  ll as RESTReqSchemaVersion,
  ug as ValidContentTypesList,
  Tg as calculateAkamaiEdgeGridHeader,
  Ag as calculateHawkHeader,
  Eg as generateJWTToken,
  Cl as generateUniqueRefId,
  Ay as getDefaultGQLRequest,
  ny as getDefaultRESTRequest,
  cg as isEqualHoppRESTRequest,
  fg as isHoppRESTRequest,
  ey as knownContentTypes,
  ql as makeCollection,
  hg as makeGQLRequest,
  og as makeHoppRESTResponseOriginalRequest,
  dg as makeRESTRequest,
  gg as parseBodyEnvVariables,
  pv as parseBodyEnvVariablesE,
  mg as parseRawKeyValueEntries,
  uv as parseRawKeyValueEntriesE,
  _g as parseTemplateString,
  yv as parseTemplateStringE,
  pg as rawKeyValueEntriesToString,
  lg as safelyExtractRESTRequest,
  yg as strictParseRawKeyValueEntriesE,
  Ty as translateToGQLRequest,
  bg as translateToNewEnvironment,
  mv as translateToNewEnvironmentVariables,
  em as translateToNewGQLCollection,
  Xy as translateToNewRESTCollection,
  ay as translateToNewRequest
};
